//@ts-nocheck
import React, { useEffect, useState, useRef } from "react";
import {
  Table,
  Button,
  Input,
  Select,
  AutoComplete,
  Form,
  DatePicker,
  Row,
  Col,
  Tabs,
  message,
  Tooltip,
} from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import { Virtuoso, type VirtuosoHandle } from "react-virtuoso";
import dayjs from "dayjs";
import QuoteIdQuickNav from "../../Components/QuoteIdQuickNav";
import {
  CalendarOutlined,
  CheckOutlined,
  LeftOutlined,
  CloseOutlined,
  EditOutlined,
  DeleteOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import {
  getManufacturers,
  getStatuses,
  createStatus,
  updateStatus,
  deleteStatus,
  getLeadFromOptions,
  createLeadFromOption,
  updateLeadFromOption,
  deleteLeadFromOption,
  getVendors,
  createVendor,
  updateVendor,
  deleteVendor,
  getOrderTracking,
  createOrderTracking,
  updateOrderTracking,
  deleteOrderTracking,
  bulkImportOrderTracking,
  getOtcReps,
  createOtcRep,
  updateOtcRep,
  deleteOtcRep,
  getOtcPmts,
  createOtcPmt,
  updateOtcPmt,
  deleteOtcPmt,
  type StatusResponse,
  type StatusPayload,
  type LeadFromResponse,
} from "../../utils/API";
import NavigationDropdown from "../../Components/NavigationDropDown";
import PageLogoutButton from "../../Components/PageLogoutButton";
import CommonHeader from "../../Components/commonHeader";
import {
  otReadRecords,
  otWriteRecords,
  otCacheHasData,
  otMergeServerRows,
  otSetMeta,
  otUpsertRecord,
  otRemoveRecord,
  otMarkDirty,
  otClearDirty,
  otGetDirty,
  extractOrderTrackingRows,
  flushOrderTrackingDirty,
} from "../../utils/orderTrackingCache";

const ORDER_TRACKING_EXPORT_COLUMNS = [
  { label: "Quote ID", key: "quoteId" },
  { label: "Sales Order", key: "salesOrder" },
  { label: "Rep", key: "rep" },
  { label: "PO Date", key: "poDate" },
  { label: "Cust PO", key: "custPo" },
  { label: "Customer", key: "customer" },
  { label: "GM", key: "gm" },
  { label: "GS", key: "gs" },
  { label: "PMT", key: "pmt" },
  { label: "PO Status", key: "poStatus" },
  { label: "Rental", key: "rental" },
  { label: "Rental Period", key: "rentalPeriod" },
  { label: "Manufacturer 1", key: "manu" },
  { label: "Model 1", key: "model" },
  { label: "Serial Number 1", key: "sn" },
  { label: "QTY 1", key: "qty" },
  { label: "Vendor 1", key: "vendor" },
  { label: "Tracking No 1", key: "trackingNo" },
  { label: "Manufacturer 2", key: "manu2" },
  { label: "Model 2", key: "model2" },
  { label: "Serial Number 2", key: "sn2" },
  { label: "QTY 2", key: "qty2" },
  { label: "Vendor 2", key: "vendor2" },
  { label: "Tracking No 2", key: "trackingNo2" },
  { label: "Manufacturer 3", key: "manu3" },
  { label: "Model 3", key: "model3" },
  { label: "Serial Number 3", key: "sn3" },
  { label: "QTY 3", key: "qty3" },
  { label: "Vendor 3", key: "vendor3" },
  { label: "Tracking No 3", key: "trackingNo3" },
  { label: "Manufacturer 4", key: "manu4" },
  { label: "Model 4", key: "model4" },
  { label: "Serial Number 4", key: "sn4" },
  { label: "QTY 4", key: "qty4" },
  { label: "Vendor 4", key: "vendor4" },
  { label: "Tracking No 4", key: "trackingNo4" },
  { label: "Manufacturer 5", key: "manu5" },
  { label: "Model 5", key: "model5" },
  { label: "Serial Number 5", key: "sn5" },
  { label: "QTY 5", key: "qty5" },
  { label: "Vendor 5", key: "vendor5" },
  { label: "Tracking No 5", key: "trackingNo5" },
  { label: "Date Shipped", key: "dateShipped" },
  { label: "RMA", key: "rma" },
  { label: "RMA Comment", key: "rmaComment" },
  { label: "Invoice Date", key: "invoiceDate" },
  { label: "Invoice No", key: "ateInvoiceNo" },
  { label: "Invoice Due Date", key: "invoiceDueDate" },
  { label: "Invoice Total", key: "invoiceTotal" },
  { label: "Paid", key: "paid" },
  { label: "Order Complete", key: "orderComplete" },
  { label: "Vendor Paid", key: "vendorPaid" },
  { label: "Vendor RMA", key: "vendorRma" },
  { label: "Lead From", key: "leadFrom" },
  { label: "Comments", key: "comments" },
];
type OrderTrackingSortDirection = "asc" | "desc";
type OrderTrackingSortRule = {
  field: string;
  direction: OrderTrackingSortDirection;
};

const ORDER_TRACKING_SORT_COLUMN_KEYS = new Set(
  ORDER_TRACKING_EXPORT_COLUMNS.map((column) => column.key),
);

const normalizeOrderTrackingSortRules = (
  rules: any,
): OrderTrackingSortRule[] => {
  if (!Array.isArray(rules)) return [];

  const seen = new Set<string>();

  return rules.reduce((normalized: OrderTrackingSortRule[], rule: any) => {
    const field = String(rule?.field || rule?.key || "").trim();
    if (!ORDER_TRACKING_SORT_COLUMN_KEYS.has(field) || seen.has(field)) {
      return normalized;
    }

    seen.add(field);
    normalized.push({
      field,
      direction:
        String(rule?.direction || "").toLowerCase() === "desc" ? "desc" : "asc",
    });

    return normalized;
  }, []);
};

const orderTrackingSortToQuery = (rules: OrderTrackingSortRule[]) => {
  const normalized = normalizeOrderTrackingSortRules(rules);
  return normalized.length > 0 ? JSON.stringify(normalized) : undefined;
};

const SORT_DIALOG_FONT: React.CSSProperties = {
  fontFamily: "Arial, sans-serif",
  fontSize: 12,
  color: "#000",
};

const sortDialogOverlay: React.CSSProperties = {
  position: "fixed",
  inset: 0,
  zIndex: 9999,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "rgba(0,0,0,0.3)",
};

const sortListBox: React.CSSProperties = {
  width: 236,
  height: 250,
  overflowY: "auto",
  background: "#fff",
  border: "1px solid #555",
};

const sortListItem = (active: boolean): React.CSSProperties => ({
  padding: "3px 8px",
  cursor: "pointer",
  whiteSpace: "nowrap",
  background: active ? "#0a64d8" : "transparent",
  color: active ? "#fff" : "#000",
});

const sortDialogHoverStyle = `
.sort-dialog-list-item:not(.sort-dialog-list-item-active):hover {
  background: #e6e6e6 !important;
}
.sort-dialog-button:not(:disabled):hover {
  background: #dcdcdc !important;
  border-color: #777 !important;
  box-shadow: inset 0 1px 0 #fff, 0 0 0 1px rgba(0, 0, 0, 0.12) !important;
}
.sort-dialog-button:not(:disabled):active {
  background: #cfcfcf !important;
}
.sort-dialog-button:disabled {
  cursor: not-allowed !important;
  opacity: 0.6;
}
`;

const sortDialogButton = (width = 110): React.CSSProperties => ({
  minWidth: width,
  height: 28,
  padding: "2px 10px",
  border: "1px solid #aaa",
  background: "#e5e5e5",
  color: "#000",
  boxShadow: "inset 0 1px 0 #fff",
  cursor: "pointer",
});

const SortDialogTitleBar: React.FC<{ title: string; onClose: () => void }> = ({
  title,
  onClose,
}) => (
  <div
    style={{
      height: 30,
      padding: "0 8px 0 10px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      background: "linear-gradient(#777, #555)",
      color: "#fff",
      fontWeight: 700,
      fontSize: 14,
    }}
  >
    <span>{title}</span>
    <div style={{ display: "flex", gap: 4 }}>
      <button
        type="button"
        style={{ width: 20, height: 18, padding: 0, lineHeight: "16px" }}
      >
        ?
      </button>
      <button
        type="button"
        style={{ width: 20, height: 18, padding: 0, lineHeight: "16px" }}
        onClick={onClose}
      >
        x
      </button>
    </div>
  </div>
);

const SortBarsIcon: React.FC<{ direction: OrderTrackingSortDirection }> = ({
  direction,
}) => {
  const heights = direction === "asc" ? [4, 7, 10] : [10, 7, 4];

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "flex-end",
        gap: 2,
        width: 16,
        height: 12,
      }}
    >
      {heights.map((height, index) => (
        <span
          key={index}
          style={{
            display: "inline-block",
            width: 3,
            height,
            background: "#000",
          }}
        />
      ))}
    </span>
  );
};

const OrderTrackingSortDialog: React.FC<{
  columns: { label: string; key: string }[];
  value: OrderTrackingSortRule[];
  onApply: (rules: OrderTrackingSortRule[]) => void;
  onClose: () => void;
}> = ({ columns, value, onApply, onClose }) => {
  const initialSelected = normalizeOrderTrackingSortRules(value);
  const [available, setAvailable] = useState(() => {
    const selectedKeys = new Set(initialSelected.map((rule) => rule.field));
    return columns.filter((column) => !selectedKeys.has(column.key));
  });
  const [selected, setSelected] =
    useState<OrderTrackingSortRule[]>(initialSelected);
  const [leftHighlight, setLeftHighlight] = useState<string | null>(null);
  const [rightHighlight, setRightHighlight] = useState<string | null>(
    initialSelected[0]?.field || null,
  );
  const [pendingDirection, setPendingDirection] = useState<OrderTrackingSortDirection>(
    initialSelected[0]?.direction || "asc",
  );

  const labelFor = (field: string) =>
    columns.find((column) => column.key === field)?.label || field;

  const moveColumn = (field: string) => {
    const column = available.find((item) => item.key === field);
    if (!column) return;

    setAvailable((prev) => prev.filter((item) => item.key !== field));
    setSelected((prev) => [...prev, { field: column.key, direction: pendingDirection }]);
    setLeftHighlight(null);
    setRightHighlight(column.key);
  };

  const moveOne = () => {
    if (leftHighlight) moveColumn(leftHighlight);
  };

  const moveAll = () => {
    if (available.length === 0) return;

    setSelected((prev) => [
      ...prev,
      ...available.map((column) => ({
        field: column.key,
        direction: pendingDirection,
      })),
    ]);
    setRightHighlight(available[0]?.key || null);
    setAvailable([]);
    setLeftHighlight(null);
  };

  const clearAll = () => {
    setAvailable(columns);
    setSelected([]);
    setLeftHighlight(null);
    setRightHighlight(null);
  };

  const activeRule =
    selected.find((rule) => rule.field === rightHighlight) || selected[0];
  const activeDirection = activeRule?.direction || pendingDirection;

  const setDirection = (direction: OrderTrackingSortDirection) => {
    setPendingDirection(direction);
    const field = rightHighlight || selected[0]?.field;
    if (!field) return;

    setRightHighlight(field);
    setSelected((prev) =>
      prev.map((rule) =>
        rule.field === field ? { ...rule, direction } : rule,
      ),
    );
  };

  const handleApply = () => {
    onApply(normalizeOrderTrackingSortRules(selected));
  };

  return (
    <div
      style={sortDialogOverlay}
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <style>{sortDialogHoverStyle}</style>
      <div
        style={{
          ...SORT_DIALOG_FONT,
          backgroundColor: "#eee",
          border: "1px solid #777",
          boxShadow: "0 2px 12px rgba(0,0,0,0.35)",
          padding: "0 0 10px",
          minWidth: 650,
        }}
      >
        <SortDialogTitleBar
          title="Sort Order Tracking Center Records"
          onClose={onClose}
        />

        <div style={{ padding: "12px 12px 0" }}>
          <div style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
            <div>
              <div style={{ fontSize: 11, marginBottom: 2 }}>
                Available Fields
              </div>
              <ul
                style={{
                  ...sortListBox,
                  listStyle: "none",
                  margin: 0,
                  padding: 0,
                }}
              >
                {available.map((column) => (
                  <li
                    key={column.key}
                    className={
                      leftHighlight === column.key
                        ? "sort-dialog-list-item sort-dialog-list-item-active"
                        : "sort-dialog-list-item"
                    }
                    style={sortListItem(leftHighlight === column.key)}
                    onMouseDown={() => {
                      setLeftHighlight(column.key);
                      setRightHighlight(null);
                    }}
                    onDoubleClick={() => moveColumn(column.key)}
                  >
                    {column.label}
                  </li>
                ))}
              </ul>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 6,
                paddingTop: 24,
              }}
            >
              <button
                type="button"
                className="sort-dialog-button"
                style={sortDialogButton()}
                onClick={moveOne}
                disabled={!leftHighlight}
              >
                Move
              </button>
              <button
                type="button"
                className="sort-dialog-button"
                style={sortDialogButton()}
                onClick={moveAll}
                disabled={available.length === 0}
              >
                Move All
              </button>
              <button
                type="button"
                className="sort-dialog-button"
                style={sortDialogButton()}
                onClick={clearAll}
                disabled={selected.length === 0}
              >
                Clear All
              </button>
            </div>

            <div>
              <div style={{ fontSize: 11, marginBottom: 2 }}>Sort Order</div>
              <ul
                style={{
                  ...sortListBox,
                  listStyle: "none",
                  margin: 0,
                  padding: 0,
                }}
              >
                {selected.map((rule) => (
                  <li
                    key={rule.field}
                    className={
                      rightHighlight === rule.field
                        ? "sort-dialog-list-item sort-dialog-list-item-active"
                        : "sort-dialog-list-item"
                    }
                    style={sortListItem(rightHighlight === rule.field)}
                    onMouseDown={() => {
                      setRightHighlight(rule.field);
                      setLeftHighlight(null);
                    }}
                  >
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 6,
                      }}
                    >
                      <SortBarsIcon direction={rule.direction} />
                      {labelFor(rule.field)}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 5,
              margin: "10px 0 0 254px",
            }}
          >
            <label
              style={{ display: "inline-flex", alignItems: "center", gap: 5, cursor: "pointer" }}
            >
              <SortBarsIcon direction="asc" />
              <input
                type="radio"
                checked={activeDirection === "asc"}
                onChange={() => setDirection("asc")}
                style={{ cursor: "pointer" }}
              />
              Ascending order
            </label>
            <label
              style={{ display: "inline-flex", alignItems: "center", gap: 5, cursor: "pointer" }}
            >
              <SortBarsIcon direction="desc" />
              <input
                type="radio"
                checked={activeDirection === "desc"}
                onChange={() => setDirection("desc")}
                style={{ cursor: "pointer" }}
              />
              Descending order
            </label>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 8,
              marginTop: 14,
            }}
          >
            <button
              type="button"
              className="sort-dialog-button"
              style={sortDialogButton(80)}
              onClick={handleApply}
            >
              Sort
            </button>
            <button
              type="button"
              className="sort-dialog-button"
              style={sortDialogButton(80)}
              onClick={onClose}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

// --- 1. Data Interface ---
interface OpenOrderData {
  key: string;
  id?: string | number;
  quoteId: string;
  rep: string;
  poDate: string;
  custPo: string;
  customer: string;
  gm: string;
  gs: string;
  shipping?: string;
  pmt: string;
  poStatus: string;
  rental: string;
  comments: string;
  salesOrder?: string;
  vendorRma?: string;
  manu?: string;
  model?: string;
  sn?: string;
  qty?: string;
  vendor?: string;
  dateShipped?: string;
  trackingNo?: string;
  rma?: string;
  rmaComment?: string;
  rentalPeriod?: string;
  manu2?: string;
  model2?: string;
  sn2?: string;
  qty2?: string;
  vendor2?: string;
  dateShipped2?: string;
  trackingNo2?: string;
  rentalPeriod2?: string;
  manu3?: string;
  model3?: string;
  sn3?: string;
  qty3?: string;
  vendor3?: string;
  trackingNo3?: string;
  manu4?: string;
  model4?: string;
  sn4?: string;
  qty4?: string;
  vendor4?: string;
  trackingNo4?: string;
  manu5?: string;
  model5?: string;
  sn5?: string;
  qty5?: string;
  vendor5?: string;
  trackingNo5?: string;
  invoiceDate?: string;
  ateInvoiceNo?: string;
  invoiceDueDate?: string;
  invoiceTotal?: string;
  paid?: string;
  orderComplete?: string;
  leadFrom?: string;
  actions?: string;
  vendorPaid?: string;
  invoiceRequestedAt?: string | null;
}

interface StatusOption {
  id: number;
  value: string;
  label: string;
  type: string;
}

interface Vendor {
  id: number;
  name: string;
}

// Generate a new unique key
const generateNewKey = () => {
  return `new-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
};

// Blank template for new record
const getBlankRecord = (): OpenOrderData => ({
  key: generateNewKey(),
  quoteId: "",
  rep: "",
  poDate: "",
  custPo: "",
  customer: "",
  gm: "",
  gs: "",
  shipping: "",
  pmt: "",
  poStatus: "",
  rental: "",
  comments: "",
});

const mapApiRecordToOpenOrder = (item: any, index: number): OpenOrderData => {
  const rentalValue =
    item?.rental === true ? "Yes" : item?.rental === false ? "No" : "";

  return {
    key: `${item?.quote_id || "row"}-${index}`,
    id: item?.id ?? item?.ot_id ?? item?.order_tracking_id ?? undefined,
    quoteId: item?.quote_id ?? "",
    rep: item?.rep ?? "",
    poDate: item?.date ?? "",
    custPo: item?.po_number ?? "",
    customer: item?.customer ?? "",
    gm:
      item?.gross_margin !== undefined && item?.gross_margin !== null
        ? String(item.gross_margin)
        : "",
    gs:
      item?.gross_sale !== undefined && item?.gross_sale !== null
        ? String(item.gross_sale)
        : "",
    shipping:
      item?.shipping_cost !== undefined && item?.shipping_cost !== null
        ? String(item.shipping_cost)
        : "",
    pmt: item?.wire ?? "",
    poStatus: item?.po_status ?? "",
    rental: rentalValue,
    comments: item?.comments ?? "",
    salesOrder: item?.sales_order ?? "",
    vendorRma: item?.vendor_rma ?? "",
    manu: item?.manu ?? "",
    model: item?.model ?? "",
    sn: item?.serial_num1 ?? "",
    qty: item?.qty !== undefined && item?.qty !== null ? String(item.qty) : "",
    vendor: item?.vendor ?? "",
    dateShipped: item?.date_shipped ?? "",
    trackingNo: item?.tracking_no ?? "",
    rma: item?.rma ?? "",
    rmaComment: item?.rma_comment ?? "",
    rentalPeriod: item?.rental_period ?? "",
    manu2: item?.manu2 ?? "",
    model2: item?.model_2 ?? "",
    sn2: item?.serial_num2 ?? "",
    qty2:
      item?.qty_2 !== undefined && item?.qty_2 !== null
        ? String(item.qty_2)
        : "",
    vendor2: item?.vendor2 ?? "",
    dateShipped2: item?.date_shipped_2 ?? "",
    trackingNo2: item?.tracking_no_2 ?? "",
    rentalPeriod2: item?.rental_period2 ?? "",
    manu3: item?.manu3 ?? "",
    model3: item?.model_3 ?? "",
    sn3: item?.serial_num3 ?? "",
    qty3:
      item?.qty_3 !== undefined && item?.qty_3 !== null
        ? String(item.qty_3)
        : "",
    vendor3: item?.vendor3 ?? "",
    trackingNo3: item?.tracking_no_3 ?? "",
    manu4: item?.manu4 ?? "",
    model4: item?.model_4 ?? "",
    sn4: item?.serial_num4 ?? "",
    qty4:
      item?.qty_4 !== undefined && item?.qty_4 !== null
        ? String(item.qty_4)
        : "",
    vendor4: item?.vendor4 ?? "",
    trackingNo4: item?.tracking_no_4 ?? "",
    manu5: item?.manu5 ?? "",
    model5: item?.model_5 ?? "",
    sn5: item?.serial_num5 ?? "",
    qty5:
      item?.qty_5 !== undefined && item?.qty_5 !== null
        ? String(item.qty_5)
        : "",
    vendor5: item?.vendor5 ?? "",
    trackingNo5: item?.tracking_no_5 ?? "",
    invoiceDate: item?.invoice_date ?? "",
    ateInvoiceNo: item?.ate_invoice_no ?? "",
    invoiceDueDate: item?.invoice_due_date ?? "",
    invoiceTotal:
      item?.invoice_total !== undefined && item?.invoice_total !== null
        ? String(item.invoice_total)
        : "",
    paid: item?.paid ?? "",
    orderComplete: item?.order_complete ?? "",
    leadFrom: item?.lead_from ?? "",
    actions: item?.actions ?? "",
    vendorPaid: item?.when ?? "",
    invoiceRequestedAt: item?.invoice_requested_at ?? null,
  };
};

// Find Content Component
const FindContent: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  const [form] = Form.useForm();

  return (
    <div className="mb-6 bg-white rounded-md border border-gray-200 shadow-sm">
      <div className="flex justify-between items-center p-4 border-b">
        <h3 className="text-base font-medium text-gray-800">Find Records</h3>
        <Button
          type="text"
          icon={<CloseOutlined />}
          onClick={onClose}
          className="hover:bg-gray-100"
          size="small"
        />
      </div>
      <div className="p-4">
        <Form form={form} layout="vertical">
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <Form.Item label="Quote ID" name="quoteId">
                <Input placeholder="Enter Quote ID" size="small" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Customer" name="customer">
                <Input placeholder="Enter customer name" size="small" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="PO Date Range" name="poDateRange">
                <DatePicker.RangePicker className="w-full" size="small" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="PO Status" name="poStatus">
                <Select placeholder="Select status" size="small">
                  <Select.Option value="shipped">Shipped</Select.Option>
                  <Select.Option value="rma">RMA</Select.Option>
                  <Select.Option value="pending">Pending</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label="Comments Contains" name="comments">
                <Input.TextArea
                  rows={2}
                  placeholder="Search in comments..."
                  size="small"
                />
              </Form.Item>
            </Col>
          </Row>
          <div className="flex justify-end gap-3 mt-4 pt-4 border-t">
            <button
              className={`px-4 py-1.5 text-sm rounded text-white bg-[#004AAD]`}
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              className={`px-4 py-1.5 text-sm rounded text-white bg-[#004AAD]`}
            >
              Search
            </button>
          </div>
        </Form>
      </div>
    </div>
  );
};

// EQR Content Component
const EQRContent: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  return (
    <div className="mb-6 bg-white rounded-md border border-gray-200 shadow-sm">
      <div className="flex justify-between items-center p-4 border-b">
        <h3 className="text-base font-medium text-gray-800">EQR Report</h3>
        <Button
          type="text"
          icon={<CloseOutlined />}
          onClick={onClose}
          className="hover:bg-gray-100"
          size="small"
        />
      </div>
      <div className="p-4 space-y-4">
        <p className="text-gray-600">
          EQR (Equipment Quotation Report) allows you to generate detailed
          equipment quotations.
        </p>
        <div className="bg-gray-50 p-4 rounded">
          <h4 className="font-medium mb-2">Available Options:</h4>
          <ul className="list-disc pl-5 space-y-1 text-gray-700">
            <li>Generate new equipment quotation</li>
            <li>View existing quotations</li>
            <li>Export to PDF/Excel</li>
            <li>Print quotation</li>
          </ul>
        </div>
        <div className="flex justify-end gap-3 mt-4 pt-4 border-t">
          <Button onClick={onClose} size="small">
            Close
          </Button>
          <Button type="primary" size="small">
            Generate Report
          </Button>
        </div>
      </div>
    </div>
  );
};

// Find All Content Component
const FindAllContent: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  const handleFindAll = () => {
    onClose();
  };

  return (
    <div className="mb-6 bg-white rounded-md border border-gray-200 shadow-sm">
      <div className="flex justify-between items-center p-4 border-b">
        <h3 className="text-base font-medium text-gray-800">
          Find All Records
        </h3>
        <Button
          type="text"
          icon={<CloseOutlined />}
          onClick={onClose}
          className="hover:bg-gray-100"
          size="small"
        />
      </div>
      <div className="p-4 space-y-4">
        <p className="text-gray-600">
          This will retrieve all open order records from the database. This
          action may take a few moments.
        </p>
        <div className="bg-yellow-50 border border-yellow-200 p-4 rounded">
          <p className="text-yellow-700 text-sm">
            <strong>Note:</strong> This operation will load all records without
            filters. Use with caution for large datasets.
          </p>
        </div>
        <div className="flex justify-end gap-3 mt-4 pt-4 border-t">
          <Button onClick={onClose} size="small">
            Cancel
          </Button>
          <Button type="primary" onClick={handleFindAll} size="small">
            Find All Records
          </Button>
        </div>
      </div>
    </div>
  );
};

// Not Paid Yet Content Component
const NotPaidYetContent: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  const notPaidData = [
    { id: "13385", customer: "CTG", amount: "$5,900", dueDate: "8/21/2009" },
    {
      id: "13080",
      customer: "Antares Electronics",
      amount: "$1,400",
      dueDate: "8/22/2009",
    },
  ];

  return (
    <div className="mb-6 bg-white rounded-md border border-gray-200 shadow-sm">
      <div className="flex justify-between items-center p-4 border-b">
        <h3 className="text-base font-medium text-gray-800">Unpaid Orders</h3>
        <Button
          type="text"
          icon={<CloseOutlined />}
          onClick={onClose}
          className="hover:bg-gray-100"
          size="small"
        />
      </div>
      <div className="p-4 space-y-4">
        <p className="text-gray-600">Showing orders that are not yet paid:</p>
        <Table
          dataSource={notPaidData}
          columns={[
            { title: "Quote ID", dataIndex: "id", key: "id" },
            { title: "Customer", dataIndex: "customer", key: "customer" },
            { title: "Amount", dataIndex: "amount", key: "amount" },
            { title: "Due Date", dataIndex: "dueDate", key: "dueDate" },
          ]}
          pagination={false}
          size="small"
        />
        <div className="flex justify-between items-center pt-2">
          <span className="text-gray-600 text-sm">
            Total Unpaid: <strong>$7,300</strong>
          </span>
          <Button type="primary" size="small">
            Generate Payment Report
          </Button>
        </div>
        <div className="flex justify-end gap-3 mt-4 pt-4 border-t">
          <Button onClick={onClose} size="small">
            Close
          </Button>
        </div>
      </div>
    </div>
  );
};

// Individual Record Component
const RecordDetail = React.memo<{
  record: OpenOrderData;
  isNew?: boolean;
  onDelete?: (key: string) => void;
  onSave?: (record: OpenOrderData, previousRecord?: OpenOrderData) => void;
  onUpdate?: (
    key: string,
    field: string,
    value: string,
    updatedRecord?: OpenOrderData,
    previousRecord?: OpenOrderData,
  ) => void;
  onSaveNew?: (record: OpenOrderData) => void;
  statusOptions: StatusOption[];
  manufacturerOptions: { value: string; label: string }[];
  vendors: Vendor[];
  sourceOptions: { value: string; label: string }[];
  actionOptions: { value: string; label: string }[];
  otcReps: { id: number; name: string }[];
  otcPmts: { id: number; name: string }[];
  onOpenStatusModal: () => void;
  onOpenVendorModal: () => void;
  onOpenSourceModal: () => void;
  onOpenActionModal: () => void;
  onOpenRepModal: () => void;
  onOpenPmtModal: () => void;
  isFindMode?: boolean;
  findCriteria?: Record<string, string>;
  onFindCriteriaChange?: (field: string, value: string) => void;
}>(
  ({
    record,
    isNew = false,
    onDelete,
    onSave,
    onUpdate,
    onSaveNew,
    statusOptions,
    manufacturerOptions,
    vendors,
    sourceOptions,
    actionOptions,
    otcReps,
    otcPmts,
    onOpenStatusModal,
    onOpenVendorModal,
    onOpenSourceModal,
    onOpenActionModal,
    onOpenRepModal,
    onOpenPmtModal,
    isFindMode = false,
    findCriteria = {},
    onFindCriteriaChange,
  }) => {
    const [isEditing, setIsEditing] = useState(true);
    const [localRecord, setLocalRecord] = useState(record);
    // Which currency field (if any) is focused — show raw digits while editing,
    // formatted (with commas) otherwise.
    const [focusedMoneyField, setFocusedMoneyField] = useState<string | null>(
      null,
    );
    const [isActionsDropdownOpen, setIsActionsDropdownOpen] = useState(false);

    useEffect(() => {
      setLocalRecord(record);
      setIsEditing(true);
    }, [record, isNew]);

    const handleInputChange = (field: string, value: string) => {
      const nextRecord = { ...localRecord, [field]: value };
      setLocalRecord(nextRecord);
      if (!isNew && onSave) {
        onSave(nextRecord, record);
      } else if (onUpdate) {
        onUpdate(record.key, field, value, nextRecord, record);
      }
    };

    const getDatePickerValue = (value: string | undefined) => {
      if (!value) return null;
      const direct = dayjs(value);
      if (direct.isValid()) return direct;

      const parts = String(value).split("/");
      if (parts.length === 3) {
        const [mm, dd, yyyy] = parts;
        const fallback = dayjs(`${yyyy}-${mm}-${dd}`);
        return fallback.isValid() ? fallback : null;
      }
      return null;
    };

    const handleSave = () => {
      if (isNew && onSaveNew) {
        onSaveNew(localRecord);
      } else if (onSave) {
        onSave(localRecord);
      }
      setIsEditing(false);
    };

    const handleCancel = () => {
      if (isNew && onDelete) {
        onDelete(record.key);
      } else {
        setLocalRecord(record);
        setIsEditing(false);
      }
    };

    const inputStyle: React.CSSProperties = {
      height: 28,
      fontSize: 12,
      borderRadius: 2,
      border: "1px solid #292929",
    };
    const vendorSelectStyle: React.CSSProperties = {
      height: 28,
      fontSize: 12,
      borderRadius: 2,
    };
    const legacySelectStyle: React.CSSProperties = {
      height: 28,
      fontSize: 12,
      borderRadius: 2,
    };
    const getFieldValue = (
      field: keyof OpenOrderData | string,
      fallback = "",
    ) => (isFindMode ? String(findCriteria?.[String(field)] || "") : fallback);

    // US currency format (e.g. "49,000.00") for display; empty stays empty and
    // non-numeric input is returned untouched.
    const formatUsCurrency = (value: any) => {
      const raw = String(value ?? "").trim();
      if (raw === "") return "";
      const num = Number(raw.replace(/[^0-9.-]/g, ""));
      if (!Number.isFinite(num)) return raw;
      return num.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    };

    // Live US format for while-typing: adds thousands separators to the integer
    // part but keeps whatever decimal the user is mid-typing (e.g. "1800.5" ->
    // "1,800.5", "1800." -> "1,800."). Non-numeric stays untouched.
    const formatUsCurrencyLive = (value: any) => {
      const raw = String(value ?? "");
      if (raw.trim() === "") return "";
      const cleaned = raw.replace(/[^0-9.]/g, "");
      const [intPart, ...rest] = cleaned.split(".");
      const groupedInt = intPart
        ? Number(intPart).toLocaleString("en-US", { maximumFractionDigits: 0 })
        : "";
      if (cleaned.indexOf(".") === -1) return groupedInt;
      return `${groupedInt}.${rest.join("")}`;
    };

    // Whole-dollar US format (e.g. "1,800") — rounds and drops decimals. Used by
    // Invoice Total so the value stays compact and never overflows the box.
    const formatWholeUsCurrency = (value: any) => {
      const raw = String(value ?? "").trim();
      if (raw === "") return "";
      const num = Number(raw.replace(/[^0-9.-]/g, ""));
      if (!Number.isFinite(num)) return raw;
      return Math.round(num).toLocaleString("en-US", {
        maximumFractionDigits: 0,
      });
    };

    const vendorOptions = [
      ...vendors.map((vendor) => ({
        value: vendor.name,
        label: vendor.name,
      })),
      {
        value: "___EDIT_VENDORS___",
        label: "Edit Vendors...",
      },
    ];

    const handleVendorSelect = (field: string, value: string) => {
      if (value === "___EDIT_VENDORS___") {
        onOpenVendorModal();
        return;
      }
      handleInputChange(field, value || "");
    };

    const updateFieldValue = (field: string, value: string) => {
      if (isFindMode) {
        onFindCriteriaChange?.(field, value);
        return;
      }
      handleInputChange(field, value);
    };

    // Wraps the search icon absolutely so the original background colour is preserved
    const wrapSearch = (input: React.ReactNode) =>
      isFindMode ? (
        <div style={{ position: "relative", width: "100%" }}>
          {input}
          <SearchOutlined
            style={{
              position: "absolute",
              right: 6,
              top: "50%",
              transform: "translateY(-50%)",
              fontSize: 10,
              color: "#808080",
              pointerEvents: "none",
            }}
          />
        </div>
      ) : (
        input
      );

    const renderFindInput = (
      field: string,
      fallback: string,
      placeholder: string,
      className?: string,
      style?: React.CSSProperties,
    ) =>
      wrapSearch(
        <Input
          className={className}
          style={style}
          value={getFieldValue(field, fallback)}
          readOnly={isFindMode ? false : !isEditing && !isNew}
          onChange={(e) => updateFieldValue(field, e.target.value)}
          placeholder={
            isFindMode ? `Search ${placeholder}` : `Enter ${placeholder}`
          }
        />,
      );

    const renderFindTextArea = (
      field: string,
      fallback: string,
      placeholder: string,
      style: React.CSSProperties,
      rows?: number,
    ) => (
      <Input.TextArea
        rows={rows}
        style={style}
        value={getFieldValue(field, fallback)}
        readOnly={isFindMode ? false : !isEditing && !isNew}
        onChange={(e) => updateFieldValue(field, e.target.value)}
        placeholder={
          isFindMode ? `Search ${placeholder}` : `Enter ${placeholder}`
        }
      />
    );

    const labelCls = "text-[11px] font-bold text-black mb-1";
    const commentsTrackingHeight = 165;
    const LEFT_W = 930;
    const COMMENTS_W = 220;
    const RIGHT_W = 300;
    const commentsTotalHeight = commentsTrackingHeight + 234;

    return (
      <section
        className="p-3 mb-4 relative"
        style={{ backgroundColor: "#CCFFCC" }}
      >
        <main>
          <section
            className="grid gap-x-1"
            style={{
              minWidth: LEFT_W + COMMENTS_W + RIGHT_W + 32,
              gridTemplateColumns: `${LEFT_W}px ${COMMENTS_W}px ${RIGHT_W}px`,
              alignItems: "start",
            }}
          >
            {/* ================= LEFT ================= */}
            <article>
              {/* Top row fields */}
              <section
                className="grid gap-x-1 gap-y-1"
                style={{
                  gridTemplateColumns: "85px 95px 95px 185px 135px 95px 95px",
                  gridAutoRows: "min-content",
                }}
              >
                {/* Rep */}
                <section
                  className="flex flex-col"
                  style={{ gridColumn: 1, gridRow: 1 }}
                >
                  <span className={labelCls}>Rep</span>
                  {isFindMode ? (
                    <Select
                      className="w-full"
                      size="small"
                      style={{ height: 28 }}
                      value={findCriteria?.rep || undefined}
                      placeholder="Search Rep..."
                      allowClear
                      showSearch
                      options={otcReps.map((r) => ({
                        value: r.name,
                        label: r.name,
                      }))}
                      onChange={(value) =>
                        onFindCriteriaChange?.("rep", value || "")
                      }
                    />
                  ) : isEditing || isNew ? (
                    <Select
                      className="w-full"
                      size="small"
                      style={{ height: 28 }}
                      value={localRecord.rep || undefined}
                      placeholder="Select Rep"
                      showSearch
                      allowClear
                      options={[
                        ...otcReps.map((r) => ({
                          value: r.name,
                          label: r.name,
                        })),
                        { value: "___EDIT_REPS___", label: "✎ Edit Reps..." },
                      ]}
                      onChange={(value) => {
                        if (value === "___EDIT_REPS___") {
                          onOpenRepModal();
                          return;
                        }
                        handleInputChange("rep", value || "");
                      }}
                    />
                  ) : (
                    <Input
                      value={localRecord.rep}
                      readOnly
                      style={inputStyle}
                    />
                  )}
                </section>

                {/* Rental, Vendor RMA and Shipping — one row under the top
                    fields. Pinned explicitly (it used to auto-place and spill
                    past its cell) and bottom-aligned so the label+input pairs
                    share a baseline. */}
                <section
                  className="flex items-center gap-4"
                  style={{ gridColumn: "1 / 5", gridRow: 2 }}
                >
                  {/* Rental */}
                  <section className="flex items-center gap-2">
                    <span
                      className="text-[11px] font-bold text-black"
                      style={{ width: 45, whiteSpace: "nowrap" }}
                    >
                      Rental?
                    </span>
                    {renderFindInput(
                      "rental",
                      localRecord.rental || "",
                      "Rental",
                      "w-[140px]",
                      inputStyle,
                    )}
                  </section>

                  {/* Vendor RMA */}
                  <section className="flex items-center gap-2">
                    <span
                      className="text-[11px] font-bold text-black"
                      style={{ width: 90, whiteSpace: "nowrap" }}
                    >
                      Vendor RMA
                    </span>
                    {renderFindInput(
                      "vendorRma",
                      localRecord.vendorRma || "",
                      "Vendor RMA",
                      "w-[160px]",
                      inputStyle,
                    )}
                  </section>
                </section>

                {/* Shipping — shares row 2 with Rental? / Vendor RMA, label
                    beside the box like those two. Spans the Gross Sale + Gross
                    Margin columns so the inline label still leaves the amount a
                    usable width. Kept as its own amount (not folded into the
                    sale) so the invoice request email can quote the shipping
                    charge separately. */}
                <section
                  className="flex items-center gap-2"
                  style={{ gridColumn: "5 / 7", gridRow: 2 }}
                >
                  <span
                    className="text-[11px] font-bold text-black"
                    style={{ width: 55, whiteSpace: "nowrap" }}
                  >
                    Shipping
                  </span>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    {wrapSearch(
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          ...inputStyle,
                          paddingLeft: 6,
                          paddingRight: 4,
                          boxSizing: "border-box",
                          backgroundColor: "#fff",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 12,
                            color: "#000",
                            flexShrink: 0,
                            lineHeight: 1,
                            userSelect: "none",
                          }}
                        >
                          $
                        </span>
                        <input
                          value={
                            isFindMode
                              ? getFieldValue("shipping", localRecord.shipping)
                              : focusedMoneyField === "shipping"
                                ? String(localRecord.shipping ?? "")
                                : formatUsCurrency(localRecord.shipping)
                          }
                          readOnly={isFindMode ? false : !isEditing && !isNew}
                          onFocus={() => setFocusedMoneyField("shipping")}
                          onBlur={() => setFocusedMoneyField(null)}
                          onChange={(e) =>
                            updateFieldValue("shipping", e.target.value)
                          }
                          placeholder={isFindMode ? "Search Shipping" : "0.00"}
                          style={{
                            flex: 1,
                            border: "none",
                            outline: "none",
                            background: "transparent",
                            fontSize: 12,
                            minWidth: 0,
                            padding: "0 4px",
                            color: "#000",
                          }}
                        />
                      </div>,
                    )}
                  </div>
                </section>

                {/* PO Date */}
                <section
                  className="flex flex-col"
                  style={{ gridColumn: 2, gridRow: 1 }}
                >
                  <span className={labelCls}>PO Date</span>
                  <DatePicker
                    className="w-full"
                    format="MM/DD/YYYY"
                    style={{ height: 28, fontSize: 10 }}
                    suffixIcon={<CalendarOutlined style={{ fontSize: 12 }} />}
                    disabled={!isFindMode && !isEditing && !isNew}
                    value={
                      isFindMode
                        ? findCriteria?.poDate
                          ? dayjs(findCriteria.poDate)
                          : null
                        : getDatePickerValue(localRecord.poDate)
                    }
                    onChange={(date) =>
                      isFindMode
                        ? onFindCriteriaChange?.(
                            "poDate",
                            date ? date.format("YYYY-MM-DD") : "",
                          )
                        : handleInputChange(
                            "poDate",
                            date ? date.format("YYYY-MM-DD") : "",
                          )
                    }
                  />
                </section>

                {/* Cust PO # */}
                <section
                  className="flex flex-col"
                  style={{ gridColumn: 3, gridRow: 1 }}
                >
                  <span className={labelCls}>Cust PO #</span>
                  <Input
                    value={getFieldValue("custPo", localRecord.custPo)}
                    readOnly={isFindMode ? false : !isEditing && !isNew}
                    onChange={(e) => updateFieldValue("custPo", e.target.value)}
                    style={{
                      ...inputStyle,
                      color: "blue", // 👈 text color
                    }}
                    placeholder={
                      isFindMode ? "Search Cust PO #" : "Enter Cust PO #"
                    }
                  />
                </section>

                {/* Customer */}
                <section
                  className="flex flex-col"
                  style={{ gridColumn: 4, gridRow: 1 }}
                >
                  <span className={labelCls}>Customer</span>
                  {wrapSearch(
                    <Input
                      value={getFieldValue("customer", localRecord.customer)}
                      readOnly={isFindMode ? false : !isEditing && !isNew}
                      onChange={(e) =>
                        updateFieldValue("customer", e.target.value)
                      }
                      style={{
                        ...inputStyle,
                        backgroundColor: "#c0c0c0",
                        fontWeight: "bold",
                        color: "blue",
                      }}
                      placeholder={
                        isFindMode ? "Search Customer" : "Enter Customer"
                      }
                    />,
                  )}
                </section>

                {/* Gross Sale */}
                <section
                  className="flex flex-col"
                  style={{ gridColumn: 5, gridRow: 1 }}
                >
                  <span className={labelCls}>Gross Sale</span>
                  {wrapSearch(
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        ...inputStyle,
                        paddingLeft: 6,
                        paddingRight: 4,
                        boxSizing: "border-box",
                        backgroundColor: "#fff",
                      }}
                    >
                      <span
                        style={{
                          fontSize: 12,
                          color: "#000",
                          flexShrink: 0,
                          lineHeight: 1,
                          userSelect: "none",
                        }}
                      >
                        $
                      </span>
                      <input
                        value={
                          isFindMode
                            ? getFieldValue("gs", localRecord.gs)
                            : focusedMoneyField === "gs"
                              ? String(localRecord.gs ?? "")
                              : formatUsCurrency(localRecord.gs)
                        }
                        readOnly={isFindMode ? false : !isEditing && !isNew}
                        onFocus={() => setFocusedMoneyField("gs")}
                        onBlur={() => setFocusedMoneyField(null)}
                        onChange={(e) => updateFieldValue("gs", e.target.value)}
                        placeholder={isFindMode ? "Search Gross Sale" : "0.00"}
                        style={{
                          flex: 1,
                          border: "none",
                          outline: "none",
                          background: "transparent",
                          fontSize: 12,
                          minWidth: 0,
                          padding: "0 4px",
                          color: "#000",
                        }}
                      />
                    </div>,
                  )}
                </section>

                {/* Gross Margin */}
                <section
                  className="flex flex-col"
                  style={{ gridColumn: 6, gridRow: 1 }}
                >
                  <span className={labelCls}>Gross Margin</span>
                  {wrapSearch(
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        ...inputStyle,
                        backgroundColor: "#c0c0c0",
                        paddingLeft: 6,
                        paddingRight: 4,
                        boxSizing: "border-box",
                      }}
                    >
                      <span
                        style={{
                          fontSize: 12,
                          color: "#000",
                          flexShrink: 0,
                          lineHeight: 1,
                          userSelect: "none",
                        }}
                      >
                        $
                      </span>
                      <input
                        value={
                          isFindMode
                            ? getFieldValue("gm", localRecord.gm)
                            : focusedMoneyField === "gm"
                              ? String(localRecord.gm ?? "")
                              : formatUsCurrency(localRecord.gm)
                        }
                        readOnly={isFindMode ? false : !isEditing && !isNew}
                        onFocus={() => setFocusedMoneyField("gm")}
                        onBlur={() => setFocusedMoneyField(null)}
                        onChange={(e) => updateFieldValue("gm", e.target.value)}
                        placeholder={
                          isFindMode ? "Search Gross Margin" : "0.00"
                        }
                        style={{
                          flex: 1,
                          border: "none",
                          outline: "none",
                          background: "transparent",
                          fontSize: 12,
                          minWidth: 0,
                          padding: "0 4px",
                          color: "#000",
                        }}
                      />
                    </div>,
                  )}
                </section>

                {/* Pmt */}
                <section
                  className="flex flex-col"
                  style={{ gridColumn: 7, gridRow: 1 }}
                >
                  <span className={labelCls}>Pmt</span>
                  {isFindMode ? (
                    <Select
                      className="w-full"
                      size="small"
                      style={{ height: 28 }}
                      value={findCriteria?.pmt || undefined}
                      placeholder="Search Pmt..."
                      allowClear
                      showSearch
                      options={otcPmts.map((p) => ({
                        value: p.name,
                        label: p.name,
                      }))}
                      onChange={(value) =>
                        onFindCriteriaChange?.("pmt", value || "")
                      }
                    />
                  ) : isEditing || isNew ? (
                    <Select
                      className="w-full"
                      size="small"
                      style={{ height: 28 }}
                      value={localRecord.pmt || undefined}
                      placeholder="Select Pmt"
                      showSearch
                      allowClear
                      options={[
                        ...otcPmts.map((p) => ({
                          value: p.name,
                          label: p.name,
                        })),
                        { value: "___EDIT_PMTS___", label: "✎ Edit Pmts..." },
                      ]}
                      onChange={(value) => {
                        if (value === "___EDIT_PMTS___") {
                          onOpenPmtModal();
                          return;
                        }
                        handleInputChange("pmt", value || "");
                      }}
                    />
                  ) : (
                    <Input
                      value={localRecord.pmt}
                      readOnly
                      style={inputStyle}
                    />
                  )}
                </section>

                {/* PO Status */}
                <section
                  className="flex flex-col"
                  style={{ gridColumn: 8, gridRow: 1 }}
                >
                  <span className={labelCls}>PO Status</span>
                  {isFindMode ? (
                    <Select
                      className="w-full custom-order-select"
                      size="small"
                      style={{ height: 28 }}
                      value={findCriteria?.poStatus || undefined}
                      placeholder="Search Status..."
                      allowClear
                      options={statusOptions.map((opt) => ({
                        value: opt.value,
                        label: opt.label,
                      }))}
                      onChange={(value) =>
                        onFindCriteriaChange?.("poStatus", value || "")
                      }
                    />
                  ) : isEditing || isNew ? (
                    <Select
                      className="w-full custom-order-select"
                      size="small"
                      style={{ height: 28 }}
                      value={localRecord.poStatus || undefined}
                      placeholder="Select Status"
                      options={[
                        ...statusOptions.map((opt) => ({
                          value: opt.value,
                          label: opt.label,
                        })),
                        { value: "edit_status", label: "✎ Edit Status..." },
                      ]}
                      onChange={(value) => {
                        if (value === "edit_status") {
                          onOpenStatusModal();
                          return;
                        }
                        handleInputChange("poStatus", value);
                      }}
                    />
                  ) : (
                    <Input
                      value={localRecord.poStatus}
                      readOnly
                      style={{ ...inputStyle, backgroundColor: "#ffffcc" }}
                    />
                  )}
                </section>
              </section>

              {/* Items */}
              <section className="mt-3">
                <section
                  className="grid gap-3"
                  style={{ gridTemplateColumns: "minmax(0, 1fr) 205px" }}
                >
                  <section className="space-y-2">
                    {[
                      {
                        idx: 0,
                        manuField: "manu",
                        modelField: "model",
                        qtyField: "qty",
                        vendorField: "vendor",
                        shipField: "dateShipped",
                        rentalField: "rentalPeriod",
                        snField: "sn",
                        trackingField: "trackingNo",
                        showSn: true,
                        showShip: true,
                        showRental: true,
                      },
                      {
                        idx: 1,
                        manuField: "manu2",
                        modelField: "model2",
                        qtyField: "qty2",
                        vendorField: "vendor2",
                        shipField: "dateShipped2",
                        rentalField: "rentalPeriod2",
                        snField: "sn2",
                        trackingField: "trackingNo2",
                        showSn: true,
                        showShip: true,
                        showRental: true,
                      },
                      {
                        idx: 2,
                        manuField: "manu3",
                        modelField: "model3",
                        qtyField: "qty3",
                        vendorField: "vendor3",
                        shipField: "",
                        rentalField: "",
                        snField: "sn3",
                        trackingField: "trackingNo3",
                        showSn: true,
                        showShip: false,
                        showRental: false,
                      },
                      {
                        idx: 3,
                        manuField: "manu4",
                        modelField: "model4",
                        qtyField: "qty4",
                        vendorField: "vendor4",
                        shipField: "",
                        rentalField: "",
                        snField: "sn4",
                        trackingField: "trackingNo4",
                        showSn: true,
                        showShip: false,
                        showRental: false,
                      },
                      {
                        idx: 4,
                        manuField: "manu5",
                        modelField: "model5",
                        qtyField: "qty5",
                        vendorField: "vendor5",
                        shipField: "",
                        rentalField: "",
                        snField: "sn5",
                        trackingField: "trackingNo5",
                        showSn: true,
                        showShip: false,
                        showRental: false,
                      },
                    ].map((cfg) => (
                      <section key={cfg.idx} className="space-y-2">
                        <section
                          className="grid gap-x-2"
                          style={{
                            gridTemplateColumns: cfg.showShip
                              ? "100px 110px 50px 205px 145px"
                              : "100px 110px 50px 205px",
                          }}
                        >
                          <section className="flex flex-col">
                            <span className={labelCls}>Manu</span>
                            {isFindMode ? (
                              <Input
                                value={getFieldValue(
                                  cfg.manuField,
                                  String(
                                    (localRecord as any)[cfg.manuField] || "",
                                  ),
                                )}
                                style={inputStyle}
                                readOnly={false}
                                onChange={(e) =>
                                  updateFieldValue(
                                    cfg.manuField,
                                    e.target.value,
                                  )
                                }
                                placeholder="Search Manu"
                              />
                            ) : (
                              <Select
                                showSearch
                                value={
                                  String(
                                    (localRecord as any)[cfg.manuField] || "",
                                  ) || undefined
                                }
                                style={legacySelectStyle}
                                disabled={!isEditing && !isNew}
                                options={manufacturerOptions}
                                onChange={(value) =>
                                  handleInputChange(
                                    cfg.manuField,
                                    String(value || ""),
                                  )
                                }
                                filterOption={(input, option) =>
                                  String(option?.label || "")
                                    .toLowerCase()
                                    .startsWith(input.toLowerCase())
                                }
                                placeholder="Select Manu..."
                              />
                            )}
                          </section>
                          <section className="flex flex-col">
                            <span className={labelCls}>Model</span>
                            <Input
                              value={getFieldValue(
                                cfg.modelField,
                                String(
                                  (localRecord as any)[cfg.modelField] || "",
                                ),
                              )}
                              style={inputStyle}
                              readOnly={
                                isFindMode ? false : !isEditing && !isNew
                              }
                              onChange={(e) =>
                                updateFieldValue(cfg.modelField, e.target.value)
                              }
                              placeholder={
                                isFindMode ? "Search Model" : "Enter Model"
                              }
                            />
                          </section>
                          <section className="flex flex-col">
                            <span className={labelCls}>Qty</span>
                            <Input
                              value={getFieldValue(
                                cfg.qtyField,
                                String(
                                  (localRecord as any)[cfg.qtyField] || "",
                                ),
                              )}
                              style={inputStyle}
                              readOnly={
                                isFindMode ? false : !isEditing && !isNew
                              }
                              onChange={(e) =>
                                updateFieldValue(cfg.qtyField, e.target.value)
                              }
                              placeholder={
                                isFindMode ? "Search Qty" : "Enter Qty"
                              }
                            />
                          </section>
                          <section className="flex flex-col">
                            <span className={labelCls}>Vendor</span>
                            {isFindMode ? (
                              <Select
                                showSearch
                                allowClear
                                value={
                                  findCriteria?.[cfg.vendorField] || undefined
                                }
                                style={vendorSelectStyle}
                                options={vendors.map((vendor) => ({
                                  value: vendor.name,
                                  label: vendor.name,
                                }))}
                                onChange={(value) =>
                                  onFindCriteriaChange?.(
                                    cfg.vendorField,
                                    value || "",
                                  )
                                }
                                filterOption={(input, option) =>
                                  String(option?.label || "")
                                    .toLowerCase()
                                    .startsWith(input.toLowerCase())
                                }
                                placeholder="Search Vendor"
                              />
                            ) : isEditing || isNew ? (
                              <Select
                                showSearch
                                allowClear
                                value={
                                  String(
                                    (localRecord as any)[cfg.vendorField] || "",
                                  ) || undefined
                                }
                                style={vendorSelectStyle}
                                options={vendorOptions}
                                onChange={(value) =>
                                  handleVendorSelect(
                                    cfg.vendorField,
                                    String(value || ""),
                                  )
                                }
                                filterOption={(input, option) =>
                                  option?.value === "___EDIT_VENDORS___" ||
                                  String(option?.label || "")
                                    .toLowerCase()
                                    .startsWith(input.toLowerCase())
                                }
                                placeholder="Select Vendor..."
                              />
                            ) : (
                              <Input
                                value={String(
                                  (localRecord as any)[cfg.vendorField] || "",
                                )}
                                style={inputStyle}
                                readOnly
                              />
                            )}
                          </section>
                          {cfg.showShip && (
                            <section className="flex flex-col">
                              <span className={labelCls}>Ship to Cust..</span>
                              {false ? (
                                <Input
                                  value={getFieldValue(
                                    cfg.shipField,
                                    String(
                                      (localRecord as any)[cfg.shipField] || "",
                                    ),
                                  )}
                                  style={inputStyle}
                                  readOnly={false}
                                  onChange={(e) =>
                                    updateFieldValue(
                                      cfg.shipField,
                                      e.target.value,
                                    )
                                  }
                                  placeholder="Search Ship to Cust."
                                />
                              ) : (
                                <DatePicker
                                  className="w-full"
                                  style={{ height: 28, fontSize: 12 }}
                                  suffixIcon={
                                    <CalendarOutlined
                                      style={{ fontSize: 12 }}
                                    />
                                  }
                                  disabled={!isFindMode && !isEditing && !isNew}
                                  value={
                                    isFindMode
                                      ? findCriteria?.[cfg.shipField]
                                        ? dayjs(findCriteria[cfg.shipField])
                                        : null
                                      : getDatePickerValue(
                                          String(
                                            (localRecord as any)[
                                              cfg.shipField
                                            ] || "",
                                          ),
                                        )
                                  }
                                  onChange={(date) =>
                                    isFindMode
                                      ? onFindCriteriaChange?.(
                                          cfg.shipField,
                                          date ? date.format("YYYY-MM-DD") : "",
                                        )
                                      : handleInputChange(
                                          cfg.shipField,
                                          date ? date.format("YYYY-MM-DD") : "",
                                        )
                                  }
                                />
                              )}
                            </section>
                          )}
                        </section>

                        {(cfg.showSn || cfg.showRental) && (
                          <section
                            className="grid items-center gap-x-2"
                            style={{ gridTemplateColumns: "465px 145px" }}
                          >
                            <div
                              className="grid items-center gap-x-2"
                              style={{
                                gridTemplateColumns:
                                  "40px 110px 60px 1fr auto",
                              }}
                            >
                              {cfg.showSn ? (
                                <>
                                  <span className={`${labelCls} text-right`}>
                                    SN
                                  </span>
                                  <Input
                                    value={getFieldValue(
                                      cfg.snField,
                                      String(
                                        (localRecord as any)[cfg.snField] || "",
                                      ),
                                    )}
                                    style={{ ...inputStyle, width: "100%" }}
                                    readOnly={
                                      isFindMode ? false : !isEditing && !isNew
                                    }
                                    onChange={(e) =>
                                      updateFieldValue(
                                        cfg.snField,
                                        e.target.value,
                                      )
                                    }
                                    placeholder={
                                      isFindMode ? "Search SN" : "Enter SN"
                                    }
                                  />
                                  <span className={`${labelCls} text-right`}>
                                    Tracking #
                                  </span>
                                  <Input
                                    value={getFieldValue(
                                      cfg.trackingField,
                                      String(
                                        (localRecord as any)[
                                          cfg.trackingField
                                        ] || "",
                                      ),
                                    )}
                                    style={{ ...inputStyle, width: "100%" }}
                                    readOnly={
                                      isFindMode ? false : !isEditing && !isNew
                                    }
                                    onChange={(e) =>
                                      updateFieldValue(
                                        cfg.trackingField,
                                        e.target.value,
                                      )
                                    }
                                    placeholder={
                                      isFindMode
                                        ? "Search Tracking #"
                                        : "Enter Tracking #"
                                    }
                                  />
                                </>
                              ) : (
                                <>
                                  <span />
                                  <span />
                                  <span />
                                  <span />
                                </>
                              )}
                              {cfg.showRental && (
                                <span className="text-[11px] font-bold text-black whitespace-nowrap">
                                  Rental Period
                                </span>
                              )}
                            </div>
                            {cfg.showRental ? (
                              <Input
                                style={{ ...inputStyle, width: "100%" }}
                                readOnly={
                                  isFindMode ? false : !isEditing && !isNew
                                }
                                value={getFieldValue(
                                  cfg.rentalField,
                                  String(
                                    (localRecord as any)[cfg.rentalField] || "",
                                  ),
                                )}
                                onChange={(e) =>
                                  updateFieldValue(
                                    cfg.rentalField,
                                    e.target.value,
                                  )
                                }
                                placeholder={
                                  isFindMode
                                    ? "Search Rental Period"
                                    : "Enter Rental Period"
                                }
                              />
                            ) : (
                              <span />
                            )}
                          </section>
                        )}
                      </section>
                    ))}
                  </section>

                  <section className="space-y-2">
                    <section className="flex flex-col">
                      <span className={labelCls}>RMA</span>
                      <Input
                        style={inputStyle}
                        readOnly={isFindMode ? false : !isEditing && !isNew}
                        value={getFieldValue("rma", localRecord.rma || "")}
                        onChange={(e) =>
                          updateFieldValue("rma", e.target.value)
                        }
                        placeholder={isFindMode ? "Search RMA" : "Enter RMA"}
                      />
                    </section>

                    <section className="flex flex-col">
                      <span className={labelCls}>RMA Comment</span>
                      <Input.TextArea
                        rows={2}
                        style={{
                          fontSize: 12,
                          borderRadius: 2,
                          border: "1px solid #292929",
                          resize: "none",
                          backgroundColor: undefined,
                        }}
                        readOnly={isFindMode ? false : !isEditing && !isNew}
                        value={getFieldValue(
                          "rmaComment",
                          localRecord.rmaComment || "",
                        )}
                        onChange={(e) =>
                          updateFieldValue("rmaComment", e.target.value)
                        }
                        placeholder={
                          isFindMode
                            ? "Search RMA Comment"
                            : "Enter RMA Comment"
                        }
                      />
                    </section>
                  </section>
                </section>
              </section>
            </article>

            {/* ================= COMMENTS ================= */}
            <aside>
              <span className={labelCls}>Comments</span>
              <Input.TextArea
                value={getFieldValue("comments", localRecord.comments || "")}
                style={{
                  fontSize: 12,
                  borderRadius: 2,
                  resize: "none",
                  height: commentsTotalHeight,
                }}
                readOnly={isFindMode ? false : !isEditing && !isNew}
                onChange={(e) => updateFieldValue("comments", e.target.value)}
                placeholder={isFindMode ? "Search Comments" : "Enter Comments"}
              />
            </aside>

            {/* ================= RIGHT ================= */}
            <aside>
              <section
                className="grid gap-x-2 gap-y-2"
                style={{ gridTemplateColumns: "1fr 1fr 1fr" }}
              >
                <section className="flex flex-col">
                  <span className={labelCls}>Invoice Date</span>
                  <DatePicker
                    className="w-full"
                    format="MM/DD/YYYY"
                    style={{ height: 28, fontSize: 10 }}
                    suffixIcon={<CalendarOutlined style={{ fontSize: 12 }} />}
                    disabled={!isFindMode && !isEditing && !isNew}
                    value={
                      isFindMode
                        ? findCriteria?.invoiceDate
                          ? dayjs(findCriteria.invoiceDate)
                          : null
                        : localRecord.invoiceDate
                          ? dayjs(localRecord.invoiceDate)
                          : null
                    }
                    onChange={(date) =>
                      isFindMode
                        ? onFindCriteriaChange?.(
                            "invoiceDate",
                            date ? date.format("YYYY-MM-DD") : "",
                          )
                        : handleInputChange(
                            "invoiceDate",
                            date ? date.format("YYYY-MM-DD") : "",
                          )
                    }
                  />
                </section>

                <section className="flex flex-col">
                  <span className={labelCls}>Invoice Number</span>
                  <Input
                    style={inputStyle}
                    readOnly={isFindMode ? false : !isEditing && !isNew}
                    value={getFieldValue(
                      "ateInvoiceNo",
                      localRecord.ateInvoiceNo || "",
                    )}
                    onChange={(e) =>
                      updateFieldValue("ateInvoiceNo", e.target.value)
                    }
                    placeholder={
                      isFindMode
                        ? "Search Invoice Number"
                        : "Enter Invoice Number"
                    }
                  />
                </section>

                <section className="flex flex-col">
                  <span className={`${labelCls} whitespace-nowrap`}>
                    Invoice Due Date
                  </span>
                  <DatePicker
                    className="w-full"
                    format="MM/DD/YYYY"
                    style={{ height: 28, fontSize: 10 }}
                    suffixIcon={<CalendarOutlined style={{ fontSize: 12 }} />}
                    disabled={!isFindMode && !isEditing && !isNew}
                    value={
                      isFindMode
                        ? findCriteria?.invoiceDueDate
                          ? dayjs(findCriteria.invoiceDueDate)
                          : null
                        : localRecord.invoiceDueDate
                          ? dayjs(localRecord.invoiceDueDate)
                          : null
                    }
                    onChange={(date) =>
                      isFindMode
                        ? onFindCriteriaChange?.(
                            "invoiceDueDate",
                            date ? date.format("YYYY-MM-DD") : "",
                          )
                        : handleInputChange(
                            "invoiceDueDate",
                            date ? date.format("YYYY-MM-DD") : "",
                          )
                    }
                  />
                </section>

                <section className="flex flex-col">
                  <span className={labelCls}>Invoice Total</span>
                  <Input
                    prefix={
                      <span style={{ color: "red", fontWeight: "bold" }}>$</span>
                    }
                    style={{
                      ...inputStyle,
                      color: "red",
                      fontWeight: "bold",
                    }}
                    styles={{
                      input: { color: "red", fontWeight: "bold" },
                    }}
                    readOnly={isFindMode ? false : !isEditing && !isNew}
                    value={
                      isFindMode
                        ? getFieldValue("invoiceTotal", localRecord.invoiceTotal)
                        : formatUsCurrencyLive(localRecord.invoiceTotal)
                    }
                    onFocus={() => setFocusedMoneyField("invoiceTotal")}
                    onBlur={() => {
                      setFocusedMoneyField(null);
                      // Round off to a whole dollar when leaving the box.
                      const rounded = formatWholeUsCurrency(
                        localRecord.invoiceTotal,
                      ).replace(/,/g, "");
                      updateFieldValue("invoiceTotal", rounded);
                    }}
                    onChange={(e) => {
                      // Store raw digits (+ optional single decimal) — the value
                      // shown is formatted live with commas via formatUsCurrencyLive.
                      let raw = e.target.value.replace(/[^0-9.]/g, "");
                      const firstDot = raw.indexOf(".");
                      if (firstDot !== -1) {
                        raw =
                          raw.slice(0, firstDot + 1) +
                          raw.slice(firstDot + 1).replace(/\./g, "");
                      }
                      updateFieldValue("invoiceTotal", raw);
                    }}
                    placeholder={isFindMode ? "Search Invoice Total" : ""}
                  />
                </section>

                <section className="flex flex-col">
                  <span className={labelCls}>Paid?</span>
                  <Input
                    style={{
                      ...inputStyle,
                      backgroundColor: undefined,
                      color: "#dc2626",
                      fontWeight: "bold",
                    }}
                    readOnly={isFindMode ? false : !isEditing && !isNew}
                    value={getFieldValue("paid", localRecord.paid || "")}
                    onChange={(e) => updateFieldValue("paid", e.target.value)}
                    placeholder={isFindMode ? "Search Paid" : "Yes/No"}
                  />
                </section>

                <section className="flex flex-col">
                  <span className="text-[11px] font-bold mb-1">
                    Vendor Paid?
                  </span>
                  <DatePicker
                    className="w-full custom-date"
                    style={{ height: 28, fontSize: 8 }}
                    suffixIcon={<CalendarOutlined style={{ fontSize: 12 }} />}
                    disabled={!isFindMode && !isEditing && !isNew}
                    value={
                      isFindMode
                        ? findCriteria?.vendorPaid
                          ? dayjs(findCriteria.vendorPaid)
                          : null
                        : getDatePickerValue(localRecord.vendorPaid)
                    }
                    onChange={(date) =>
                      isFindMode
                        ? onFindCriteriaChange?.(
                            "vendorPaid",
                            date ? date.format("YYYY-MM-DD") : "",
                          )
                        : handleInputChange(
                            "vendorPaid",
                            date ? date.format("YYYY-MM-DD") : "",
                          )
                    }
                  />
                </section>

                {/* Action + Order Complete */}
                <section className="col-span-3">
                  <div
                    className="grid gap-2"
                    style={{ gridTemplateColumns: "68% 32%" }}
                  >
                    <section className="flex flex-col">
                      <span className={labelCls}>Actions</span>
                      <AutoComplete
                        className="w-full [&_.ant-select-selection-search-input]:!text-[11px] [&_.ant-select-selection-search-input]:!text-red-600 [&_.ant-select-selection-search-input]:!font-semibold [&_.ant-select-selection-item]:!text-[11px] [&_.ant-select-selection-item]:!text-red-600 [&_.ant-select-selection-item]:!font-semibold"
                        size="small"
                        style={{ minHeight: 28 }}
                        disabled={!isFindMode && !isEditing && !isNew}
                        allowClear
                        open={isActionsDropdownOpen}
                        onFocus={() => setIsActionsDropdownOpen(true)}
                        placeholder={
                          isFindMode ? "Search Action" : "Select or type Action"
                        }
                        value={
                          isFindMode
                            ? findCriteria?.actions || ""
                            : localRecord.actions || ""
                        }
                        filterOption={false}
                        onSearch={(input) => {
                          setIsActionsDropdownOpen(!input);
                        }}
                        options={
                          isFindMode
                            ? actionOptions
                            : [
                                ...actionOptions,
                                {
                                  value: "edit_action",
                                  label: (
                                    <span className="flex items-center gap-1">
                                      <EditOutlined /> Edit Actions...
                                    </span>
                                  ),
                                },
                              ]
                        }
                        onChange={(value) => {
                          if (value === "edit_action") {
                            onOpenActionModal();
                            return;
                          }
                          updateFieldValue("actions", value || "");
                        }}
                        onSelect={() => setIsActionsDropdownOpen(false)}
                        onBlur={() => setIsActionsDropdownOpen(false)}
                      />
                    </section>

                    <section className="flex flex-col">
                      <span className={labelCls}>Order Complete</span>
                      <Select
                        size="small"
                        value={
                          isFindMode
                            ? findCriteria?.["orderComplete"] || undefined
                            : localRecord.orderComplete || undefined
                        }
                        placeholder="Select Status"
                        disabled={!isFindMode && !isEditing && !isNew}
                        onChange={(value) =>
                          updateFieldValue("orderComplete", value)
                        }
                        popupMatchSelectWidth={false}
                        style={{
                          width: "100%",
                          fontWeight:
                            localRecord.orderComplete?.toLowerCase() ===
                            "closed"
                              ? "bold"
                              : undefined,
                        }}
                        options={[
                          { value: "Active order", label: "Active order" },
                          { value: "Closed", label: "Closed" },
                        ]}
                      />
                    </section>

                    <section className="col-span-3 mt-2">
                      <div
                        className="grid items-center gap-2"
                        style={{
                          gridTemplateColumns: "65px 1fr",
                          columnGap: 6,
                        }}
                      >
                        <span className={labelCls}>Lead From</span>
                        {isFindMode ? (
                          <Select
                            className="w-full"
                            size="small"
                            style={{ height: 28 }}
                            value={findCriteria?.leadFrom || undefined}
                            placeholder="Search Lead From..."
                            allowClear
                            showSearch
                            options={sourceOptions}
                            filterOption={(input, option) =>
                              (option?.label ?? "")
                                .toLowerCase()
                                .startsWith(input.toLowerCase())
                            }
                            onChange={(value) =>
                              onFindCriteriaChange?.("leadFrom", value || "")
                            }
                          />
                        ) : (
                          <Select
                            className="w-full"
                            size="small"
                            options={[
                              ...sourceOptions,
                              {
                                value: "edit_source",
                                label: "Edit Lead From...",
                              },
                            ]}
                            style={{ height: 28 }}
                            disabled={!isEditing && !isNew}
                            placeholder="Select Source"
                            value={localRecord.leadFrom || undefined}
                            onChange={(value) => {
                              if (value === "edit_source") {
                                onOpenSourceModal();
                                return;
                              }
                              handleInputChange("leadFrom", value);
                            }}
                          />
                        )}
                      </div>
                      {!isFindMode && localRecord.invoiceRequestedAt && (
                        <div
                          className="mt-1 inline-flex items-center gap-1 rounded-full px-2 py-1 text-[13px] font-semibold"
                          style={{
                            backgroundColor: "#e6f7e9",
                            color: "#0a7a2f",
                            border: "1px solid #8fd3a0",
                          }}
                        >
                          <CheckOutlined style={{ fontSize: 12 }} />
                          Invoice requested{" "}
                          {dayjs(localRecord.invoiceRequestedAt).format(
                            "MM/DD/YY",
                          )}
                        </div>
                      )}
                    </section>
                  </div>
                </section>
              </section>
            </aside>
          </section>
        </main>

        {/* Quote ID and Sales Order # Row */}
        {/* Black divider; -mx-3/px-3 stretch it to the section edges so its left
          end meets the selected record's left line (they connect at the corner). */}
        <footer className="flex items-center gap-4 mt-2 pt-2 border-t-2 border-black -mx-3 px-3">
          <section className="flex items-center gap-2">
            <span className="text-[11px] font-bold text-black">Quote ID</span>
            <div className="relative group">
              {renderFindInput(
                "quoteId",
                localRecord.quoteId,
                "Quote ID",
                "w-[113px] h-[31px] border b-[#D2D2D2] pr-7",
                inputStyle,
              )}
              {!isFindMode && (
                <QuoteIdQuickNav
                  quoteId={localRecord.quoteId}
                  targets={[
                    { path: "/open-order", label: "Open Order" },
                    { path: "/otc", label: "OTC Snapshot" },
                    { path: "/Quotes", label: "Quote", useQueryParam: true },
                  ]}
                />
              )}
            </div>
          </section>

          <section className="flex items-center gap-2">
            <span className="text-[11px] font-bold text-black">
              Sales Order #
            </span>
            {renderFindInput(
              "salesOrder",
              localRecord.salesOrder || "",
              "Sales Order #",
              "w-[120px]",
              inputStyle,
            )}
          </section>
        </footer>
      </section>
    );
  },
);

const OrderTracking = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const OT_SELECTED_ID_KEY = "orderTrackingSelectedId";
  const pendingOpenRef = useRef<{ id?: any; quoteId?: any } | null>(
    location?.state
      ? {
          id: (location.state as any)?.openRecordId,
          quoteId: (location.state as any)?.openQuoteId,
        }
      : (() => {
          try {
            const savedId = localStorage.getItem(OT_SELECTED_ID_KEY);
            return savedId ? { id: savedId } : null;
          } catch {
            return null;
          }
        })(),
  );
  // Virtualized record-list refs
  const virtuosoRef = useRef<VirtuosoHandle | null>(null);
  const pendingScrollIndexRef = useRef<number | null>(null);
  const isProgrammaticScroll = useRef(false);
  // Timestamp of the last local edit — background revalidate skips refreshing
  // the on-screen rows if the user edited recently, to avoid clobbering input.
  const lastEditAtRef = useRef(0);
  const [dataSource, setDataSource] = useState<OpenOrderData[]>([]);
  const OT_STATE_KEY = "orderTrackingState";
  const _otSaved = (() => {
    try {
      return JSON.parse(localStorage.getItem(OT_STATE_KEY) || "null") || {};
    } catch {
      return {};
    }
  })();
  const [currentIndex, setCurrentIndex] = useState(_otSaved.currentIndex || 0);
  const otInitialLoadRef = useRef(true);
  const navBeltRef = useRef<HTMLDivElement | null>(null);
  const navBeltDragging = useRef(false);
  const [navBeltDragIdx, setNavBeltDragIdx] = useState<number | null>(null);
  const [activeContent, setActiveContent] = useState<string | null>(null);
  const [hasUserNavigated, setHasUserNavigated] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [statusOptions, setStatusOptions] = useState<StatusOption[]>([]);
  const [manufacturerOptions, setManufacturerOptions] = useState<
    { value: string; label: string }[]
  >([]);
  const [vendors, setVendors] = useState<Vendor[]>([]);
  const [vendorsLoading, setVendorsLoading] = useState(false);
  const [sourceOptions, setSourceOptions] = useState<
    { value: string; label: string; id?: number }[]
  >([]);
  const [isFindMode, setIsFindMode] = useState(_otSaved.isFindMode || false);
  const [findCriteria, setFindCriteria] = useState<Record<string, string>>(
    _otSaved.findCriteria || {},
  );
  const [currentFilters, setCurrentFilters] = useState<Record<string, any>>(
    _otSaved.currentFilters || {},
  );
  const [sortRules, setSortRules] = useState<OrderTrackingSortRule[]>(
    normalizeOrderTrackingSortRules(_otSaved.sortRules),
  );
  const [isSortDialogOpen, setIsSortDialogOpen] = useState(false);
  const [unfilteredTotal, setUnfilteredTotal] = useState(0);
  const [recordInputValue, setRecordInputValue] = useState("");
  const [isStatusModalOpen, setIsStatusModalOpen] = useState(false);
  const [editingStatus, setEditingStatus] = useState({ index: -1, value: "" });
  const [newStatus, setNewStatus] = useState("");
  const [isVendorModalOpen, setIsVendorModalOpen] = useState(false);
  const [editingVendor, setEditingVendor] = useState<Vendor | null>(null);
  const [newVendorName, setNewVendorName] = useState("");
  const [isSourceModalOpen, setIsSourceModalOpen] = useState(false);
  const [editingSource, setEditingSource] = useState({
    index: -1,
    value: "",
    id: 0,
  });
  const [newSource, setNewSource] = useState("");
  const [actionOptions, setActionOptions] = useState<StatusOption[]>([]);
  const [isActionModalOpen, setIsActionModalOpen] = useState(false);
  const [editingAction, setEditingAction] = useState({ index: -1, value: "" });
  const [newAction, setNewAction] = useState("");
  const [otcReps, setOtcReps] = useState<{ id: number; name: string }[]>([]);
  const [isRepModalOpen, setIsRepModalOpen] = useState(false);
  const [editingRep, setEditingRep] = useState<{
    id: number;
    name: string;
  } | null>(null);
  const [newRepName, setNewRepName] = useState("");
  const [otcPmts, setOtcPmts] = useState<{ id: number; name: string }[]>([]);
  const [isPmtModalOpen, setIsPmtModalOpen] = useState(false);
  const [editingPmt, setEditingPmt] = useState<{
    id: number;
    name: string;
  } | null>(null);
  const [newPmtName, setNewPmtName] = useState("");
  const autosaveTimersRef = useRef<
    Record<string, ReturnType<typeof setTimeout>>
  >({});
  const pendingPayloadRef = useRef<Record<string, Record<string, any>>>({});
  const STATUS_TYPE_ORDER_TRACKING = "order_tracking";
  const STATUS_TYPE_OTC_ACTIONS = "otc-actions";

  const refreshOrderStatuses = async () => {
    try {
      const statusResponse = await getStatuses();
      if (Array.isArray(statusResponse) && statusResponse.length > 0) {
        const mappedStatuses = statusResponse
          .filter((item) => item.type === STATUS_TYPE_ORDER_TRACKING)
          .map((item) => ({
            id: item.id,
            value: item.statusName,
            label: item.statusName,
            type: item.type,
          }));
        setStatusOptions(mappedStatuses);
      } else {
        setStatusOptions([]);
      }
    } catch (error: any) {
      message.error(
        error?.response?.data?.message || "Failed to load statuses",
      );
    }
  };

  const refreshSources = async () => {
    try {
      const sourcesResponse = await getLeadFromOptions();
      if (Array.isArray(sourcesResponse) && sourcesResponse.length > 0) {
        setSourceOptions(
          sourcesResponse.map((item: LeadFromResponse) => ({
            value: item.name,
            label: item.name,
            id: item.id,
          })),
        );
      } else {
        setSourceOptions([]);
      }
    } catch (error: any) {
      message.error(error?.response?.data?.message || "Failed to load sources");
    }
  };

  const refreshVendors = async () => {
    setVendorsLoading(true);
    try {
      const response = await getVendors();

      if (Array.isArray(response)) {
        setVendors(response);
      } else if (
        response &&
        typeof response === "object" &&
        "data" in response &&
        Array.isArray(response.data)
      ) {
        setVendors(response.data);
      } else if (
        response &&
        typeof response === "object" &&
        "vendors" in response &&
        Array.isArray(response.vendors)
      ) {
        setVendors(response.vendors);
      } else {
        setVendors([]);
      }
    } catch (error: any) {
      message.error(error?.response?.data?.message || "Failed to load vendors");
      setVendors([]);
    } finally {
      setVendorsLoading(false);
    }
  };

  const handleAddVendor = async () => {
    if (!newVendorName.trim()) {
      message.warning("Please enter a vendor name");
      return;
    }

    try {
      const response = await createVendor({ name: newVendorName.trim() });
      const createdVendor = response?.data || response;
      setVendors((prev) => [...prev, createdVendor]);
      setNewVendorName("");
    } catch (error: any) {
      message.error(error?.response?.data?.message || "Failed to add vendor");
    }
  };

  const handleUpdateVendor = async () => {
    if (!editingVendor?.name.trim()) {
      message.warning("Please enter a vendor name");
      return;
    }

    try {
      const response = await updateVendor(editingVendor.id, {
        name: editingVendor.name.trim(),
      });
      const updatedVendor = response?.data || response;
      setVendors((prev) =>
        prev.map((vendor) =>
          vendor.id === editingVendor.id
            ? {
                ...vendor,
                name: updatedVendor?.name || editingVendor.name.trim(),
              }
            : vendor,
        ),
      );
      setEditingVendor(null);
    } catch (error: any) {
      message.error(
        error?.response?.data?.message || "Failed to update vendor",
      );
    }
  };

  const handleDeleteVendor = async (id: number, name: string) => {
    const vendorFields = ["vendor", "vendor2", "vendor3", "vendor4", "vendor5"];
    const isUsed = dataSource.some((record) =>
      vendorFields.some(
        (field) => String((record as any)[field] || "") === name,
      ),
    );

    if (isUsed) {
      message.warning(
        `Cannot delete "${name}" because it's being used in order tracking`,
      );
      return;
    }

    try {
      await deleteVendor(id);
      setVendors((prev) => prev.filter((vendor) => vendor.id !== id));
    } catch (error: any) {
      message.error(
        error?.response?.data?.message || "Failed to delete vendor",
      );
    }
  };

  const handleEditStatus = (index: number) => {
    setEditingStatus({ index, value: statusOptions[index].label });
  };

  const handleSaveStatus = async () => {
    if (editingStatus.index < 0 || !editingStatus.value.trim()) return;
    const targetStatus = statusOptions[editingStatus.index];
    if (!targetStatus?.id) return;

    try {
      await updateStatus(targetStatus.id, {
        statusName: editingStatus.value.trim(),
        type: STATUS_TYPE_ORDER_TRACKING,
      });
      // message.success("Status updated successfully");
      setEditingStatus({ index: -1, value: "" });
      await refreshOrderStatuses();
    } catch (error: any) {
      message.error(
        error?.response?.data?.message || "Failed to update status",
      );
    }
  };

  const handleAddStatus = async () => {
    if (!newStatus.trim()) return;
    try {
      await createStatus({
        statusName: newStatus.trim(),
        type: STATUS_TYPE_ORDER_TRACKING,
      });
      // message.success("Status added successfully");
      setNewStatus("");
      await refreshOrderStatuses();
    } catch (error: any) {
      message.error(error?.response?.data?.message || "Failed to add status");
    }
  };

  const handleDeleteStatus = async (index: number) => {
    const targetStatus = statusOptions[index];
    if (!targetStatus?.id) return;
    try {
      await deleteStatus(targetStatus.id);
      // message.success("Status deleted successfully");
      await refreshOrderStatuses();
    } catch (error: any) {
      message.error(
        error?.response?.data?.message || "Failed to delete status",
      );
    }
  };

  const handleEditSource = (index: number) => {
    setEditingSource({
      index,
      value: sourceOptions[index].label,
      id: sourceOptions[index].id || 0,
    });
  };

  const handleSaveSource = async () => {
    if (editingSource.index < 0 || !editingSource.value.trim()) return;
    try {
      await updateLeadFromOption(editingSource.id, {
        name: editingSource.value.trim(),
      });
      setEditingSource({ index: -1, value: "", id: 0 });
      await refreshSources();
    } catch (error: any) {
      message.error(
        error?.response?.data?.message || "Failed to update source",
      );
    }
  };

  const handleAddSource = async () => {
    if (!newSource.trim()) return;
    try {
      await createLeadFromOption({
        name: newSource.trim(),
      });
      setNewSource("");
      await refreshSources();
    } catch (error: any) {
      message.error(error?.response?.data?.message || "Failed to add source");
    }
  };

  const handleDeleteSource = async (index: number) => {
    const targetSource = sourceOptions[index];
    if (!targetSource?.id) return;
    try {
      await deleteLeadFromOption(targetSource.id);
      await refreshSources();
    } catch (error: any) {
      message.error(
        error?.response?.data?.message || "Failed to delete source",
      );
    }
  };

  // ---------------- OTC Actions (status table, type "otc-actions") ----------------
  const refreshActions = async () => {
    try {
      const statusResponse = await getStatuses();
      if (Array.isArray(statusResponse) && statusResponse.length > 0) {
        const mappedActions = statusResponse
          .filter((item) => item.type === STATUS_TYPE_OTC_ACTIONS)
          .map((item) => ({
            id: item.id,
            value: item.statusName,
            label: item.statusName,
            type: item.type,
          }));
        setActionOptions(mappedActions);
      } else {
        setActionOptions([]);
      }
    } catch (error: any) {
      message.error(error?.response?.data?.message || "Failed to load actions");
    }
  };

  const handleEditAction = (index: number) => {
    setEditingAction({ index, value: actionOptions[index].label });
  };

  const handleSaveAction = async () => {
    if (editingAction.index < 0 || !editingAction.value.trim()) return;
    const targetAction = actionOptions[editingAction.index];
    if (!targetAction?.id) return;
    try {
      await updateStatus(targetAction.id, {
        statusName: editingAction.value.trim(),
        type: STATUS_TYPE_OTC_ACTIONS,
      });
      setEditingAction({ index: -1, value: "" });
      await refreshActions();
    } catch (error: any) {
      message.error(
        error?.response?.data?.message || "Failed to update action",
      );
    }
  };

  const handleAddAction = async () => {
    if (!newAction.trim()) return;
    try {
      await createStatus({
        statusName: newAction.trim(),
        type: STATUS_TYPE_OTC_ACTIONS,
      });
      setNewAction("");
      await refreshActions();
    } catch (error: any) {
      message.error(error?.response?.data?.message || "Failed to add action");
    }
  };

  const handleDeleteAction = async (index: number) => {
    const targetAction = actionOptions[index];
    if (!targetAction?.id) return;
    try {
      await deleteStatus(targetAction.id);
      await refreshActions();
    } catch (error: any) {
      message.error(
        error?.response?.data?.message || "Failed to delete action",
      );
    }
  };

  const handleEnterFindMode = () => {
    setActiveContent(null);
    setFindCriteria({});
    setIsFindMode(true);
  };

  const handleCancelFind = () => {
    setIsFindMode(false);
    setFindCriteria({});
  };

  const handlePerformFind = async () => {
    const hasAny = Object.values(findCriteria).some((v) =>
      String(v || "").trim(),
    );
    if (!hasAny) {
      message.warning("Enter at least one search value");
      return;
    }
    const criteria = { ...findCriteria };
    setIsFindMode(false);
    setFindCriteria({});
    setCurrentFilters(criteria);
    try {
      await loadOrderTracking(criteria);
    } catch (err: any) {
      message.error(err?.response?.data?.message || "Search failed");
    }
  };

  const handleButtonClick = (type: string) => {
    if (type === "find") {
      handleEnterFindMode();
      return;
    }
    if (activeContent === type) {
      setActiveContent(null);
    } else {
      setActiveContent(type);
    }
  };

  const handleCloseContent = () => {
    setActiveContent(null);
  };

  const parseNumberOrNull = (value: string | undefined) => {
    const trimmed = String(value || "").trim();
    if (!trimmed) return null;
    const parsed = Number(trimmed.replace(/,/g, ""));
    return Number.isFinite(parsed) ? parsed : null;
  };

  // Like parseNumberOrNull but rounds to the nearest whole dollar on save.
  const parseRoundedOrNull = (value: string | undefined) => {
    const parsed = parseNumberOrNull(value);
    return parsed === null ? null : Math.round(parsed);
  };

  const parseIntegerOrNull = (value: string | undefined) => {
    const trimmed = String(value || "").trim();
    if (!trimmed) return null;
    const parsed = Number(trimmed);
    return Number.isInteger(parsed) ? parsed : null;
  };

  const parseBooleanOrNull = (value: string | undefined) => {
    const normalized = String(value || "")
      .trim()
      .toLowerCase();
    if (!normalized) return null;
    if (["true", "1", "yes", "y"].includes(normalized)) return true;
    if (["false", "0", "no", "n"].includes(normalized)) return false;
    return null;
  };

  const buildCreatePayload = (record: OpenOrderData) => ({
    quote_id: record.quoteId || null,
    rep: record.rep || null,
    date: record.poDate || null,
    po_number: record.custPo || null,
    customer: record.customer || null,
    gross_margin: parseNumberOrNull(record.gm),
    gross_sale: parseNumberOrNull(record.gs),
    shipping_cost: parseNumberOrNull(record.shipping),
    wire: record.pmt || null,
    po_status: record.poStatus || null,
    rental: parseBooleanOrNull(record.rental),
    comments: record.comments || null,
    sales_order: record.salesOrder || null,
    vendor_rma: record.vendorRma || null,
    manu: record.manu || null,
    model: record.model || null,
    serial_num1: record.sn || null,
    qty: parseIntegerOrNull(record.qty),
    vendor: record.vendor || null,
    date_shipped: record.dateShipped || null,
    tracking_no: record.trackingNo || null,
    rma: record.rma || null,
    rma_comment: record.rmaComment || null,
    rental_period: record.rentalPeriod || null,
    manu2: record.manu2 || null,
    model_2: record.model2 || null,
    serial_num2: record.sn2 || null,
    qty_2: parseIntegerOrNull(record.qty2),
    vendor2: record.vendor2 || null,
    date_shipped_2: record.dateShipped2 || null,
    tracking_no_2: record.trackingNo2 || null,
    rental_period2: record.rentalPeriod2 || null,
    manu3: record.manu3 || null,
    model_3: record.model3 || null,
    serial_num3: record.sn3 || null,
    qty_3: parseIntegerOrNull(record.qty3),
    vendor3: record.vendor3 || null,
    tracking_no_3: record.trackingNo3 || null,
    manu4: record.manu4 || null,
    model_4: record.model4 || null,
    serial_num4: record.sn4 || null,
    qty_4: parseIntegerOrNull(record.qty4),
    vendor4: record.vendor4 || null,
    tracking_no_4: record.trackingNo4 || null,
    manu5: record.manu5 || null,
    model_5: record.model5 || null,
    serial_num5: record.sn5 || null,
    qty_5: parseIntegerOrNull(record.qty5),
    vendor5: record.vendor5 || null,
    tracking_no_5: record.trackingNo5 || null,
    invoice_date: record.invoiceDate || null,
    ate_invoice_no: record.ateInvoiceNo || null,
    invoice_due_date: record.invoiceDueDate || null,
    invoice_total: parseRoundedOrNull(record.invoiceTotal),
    invoice_requested_at: record.invoiceRequestedAt || null,
    paid: record.paid || null,
    order_complete: record.orderComplete || null,
    lead_from: record.leadFrom || null,
    actions: record.actions || null,
    when: record.vendorPaid || null,
  });

  // Background refresh: pull fresh server rows, keep the cache in sync, and
  // (only when it's safe) update the on-screen rows. Never blocks the UI.
  const revalidateOrderTracking = async () => {
    try {
      const response = await getOrderTracking({ page: 1, limit: 10000 });
      const rows = extractOrderTrackingRows(response);
      const merged = otMergeServerRows(rows);
      otWriteRecords(merged);
      otSetMeta({ lastSyncedAt: Date.now() });

      // Don't refresh the visible rows if there are unsynced edits or the user
      // edited within the last few seconds (would interrupt typing).
      if (
        otGetDirty().length === 0 &&
        Date.now() - lastEditAtRef.current > 4000
      ) {
        const mapped = merged.map(mapApiRecordToOpenOrder);
        setDataSource(mapped);
        setUnfilteredTotal(mapped.length);
      }
    } catch {
      // Offline / server error — keep showing the cached data.
    }
  };

  const loadOrderTracking = async (
    filters: Record<string, any> = currentFilters,
    opts: {
      preferCache?: boolean;
      keepNavigation?: boolean;
      sortRules?: OrderTrackingSortRule[];
    } = {},
  ) => {
    const {
      preferCache = false,
      keepNavigation = false,
      sortRules: sortRulesOverride,
    } = opts;
    const activeSortRules = normalizeOrderTrackingSortRules(
      sortRulesOverride ?? sortRules,
    );
    const sortQuery = orderTrackingSortToQuery(activeSortRules);
    const hasSort = activeSortRules.length > 0;
    const hasFilter = filters && Object.keys(filters).length > 0;

    // Cache-first: on the initial unfiltered load, paint instantly from the
    // local cache, then revalidate in the background.
    if (preferCache && !hasFilter && !hasSort && otCacheHasData()) {
      try {
        const mapped = otReadRecords().map(mapApiRecordToOpenOrder);
        if (!keepNavigation) setHasUserNavigated(false);
        setDataSource(mapped);
        setUnfilteredTotal(mapped.length);
        revalidateOrderTracking();
        return mapped;
      } catch {
        // Corrupt cache — fall through to the network path.
      }
    }

    setIsLoading(true);
    try {
      // Single request — no parallel second call to avoid cache/ordering mismatch
      const response = await getOrderTracking({
        page: 1,
        limit: 10000,
        ...filters,
        ...(sortQuery ? { sort: sortQuery } : {}),
      });

      const rows = extractOrderTrackingRows(response);
      const mapped = rows.map(mapApiRecordToOpenOrder);
      // keepNavigation is used by mutation reloads (e.g. adding a record) that
      // set their own currentIndex afterwards. Resetting hasUserNavigated here
      // would let the index-manager effect race them back to index 0.
      if (!keepNavigation) setHasUserNavigated(false);
      setDataSource(mapped);

      if (!hasFilter) {
        // On unfiltered load, capture the true total
        setUnfilteredTotal(mapped.length);
      }

      if (!hasFilter && !hasSort) {
        // Keep the local cache in sync with server truth (preserving any
        // unsynced local edits in the dirty queue).
        otWriteRecords(otMergeServerRows(rows));
        otSetMeta({ lastSyncedAt: Date.now() });
      }
      // When filtered, unfilteredTotal keeps its last unfiltered value — no extra call needed

      return mapped;
    } catch (error) {
      console.error("Failed to load order tracking records:", error);
      return [];
    } finally {
      setIsLoading(false);
    }
  };

  const refreshOtcReps = async () => {
    try {
      const res = await getOtcReps();
      setOtcReps(Array.isArray(res?.data) ? res.data : []);
    } catch {
      /* silent */
    }
  };

  const refreshOtcPmts = async () => {
    try {
      const res = await getOtcPmts();
      setOtcPmts(Array.isArray(res?.data) ? res.data : []);
    } catch {
      /* silent */
    }
  };

  useEffect(() => {
    // Don't save during initial load — currentIndex is temporarily 0 before data arrives
    if (!otInitialLoadRef.current) {
      localStorage.setItem(
        OT_STATE_KEY,
        JSON.stringify({
          currentIndex,
          isFindMode,
          findCriteria,
          currentFilters,
          sortRules,
        }),
      );
    }
  }, [currentIndex, isFindMode, findCriteria, currentFilters, sortRules]);

  useEffect(() => {
    const hasFilter =
      _otSaved.currentFilters &&
      Object.keys(_otSaved.currentFilters).length > 0;
    const hasSort = sortRules.length > 0;
    // Unfiltered initial load → cache-first (instant) + background revalidate.
    // Filtered load → always hit the server (filtered results aren't cached).
    loadOrderTracking(hasFilter ? _otSaved.currentFilters : {}, {
      preferCache: !hasFilter && !hasSort,
    });
    refreshOrderStatuses();
    refreshSources();
    refreshActions();
    refreshVendors();
    loadManufacturers();
    refreshOtcReps();
    refreshOtcPmts();

    // Retry any saves that didn't reach the DB, now and whenever the network
    // comes back.
    flushOrderTrackingDirty();
    const onOnline = () => flushOrderTrackingDirty();
    window.addEventListener("online", onOnline);
    return () => window.removeEventListener("online", onOnline);
  }, []);

  useEffect(() => {
    if (dataSource.length === 0) {
      setCurrentIndex(0);
      return;
    }
    if (pendingOpenRef.current) {
      const { id, quoteId } = pendingOpenRef.current;
      const matchIdx = dataSource.findIndex((r) => {
        if (id != null && r.id != null && String(r.id) === String(id))
          return true;
        if (quoteId && r.quoteId && String(r.quoteId) === String(quoteId))
          return true;
        return false;
      });
      if (matchIdx >= 0) {
        setCurrentIndex(matchIdx);
        setHasUserNavigated(true);
        pendingScrollIndexRef.current = matchIdx;
        pendingOpenRef.current = null;
        navigate(location.pathname, { replace: true });
        return;
      }
      const missingLabel = quoteId
        ? `Quote ID ${quoteId}`
        : id != null
          ? `record ${id}`
          : "that record";
      message.warning(
        `No Order Tracking record found for ${missingLabel}. Showing the latest Order Tracking record.`,
      );
      setCurrentIndex(0);
      setHasUserNavigated(true);
      pendingScrollIndexRef.current = 0;
      pendingOpenRef.current = null;
      navigate(location.pathname, { replace: true });
      return;
    }
    // A programmatic scroll target is pending (e.g. a record was just added or
    // the selection is being restored) — don't override currentIndex here.
    if (pendingScrollIndexRef.current != null) return;
    if (!hasUserNavigated) {
      if (otInitialLoadRef.current && _otSaved.currentIndex > 0) {
        otInitialLoadRef.current = false;
        const restoredIdx = Math.min(
          _otSaved.currentIndex,
          dataSource.length - 1,
        );
        setCurrentIndex(restoredIdx);
        setHasUserNavigated(true);
        pendingScrollIndexRef.current = restoredIdx;
        return;
      }
      otInitialLoadRef.current = false;
      setCurrentIndex(0);
      return;
    }
    if (currentIndex > dataSource.length - 1) {
      setCurrentIndex(dataSource.length - 1);
    }
  }, [dataSource, currentIndex, hasUserNavigated, navigate, location.pathname]);

  // Perform any pending scroll (restore / open-from-another-page / new record)
  // once the virtualized list has mounted. currentIndex is in the deps so that
  // a pending scroll set *after* setDataSource has committed (e.g. adding a new
  // record over a slow network) still fires — otherwise the effect would only
  // run on the dataSource change, before the ref was set, and never scroll.
  useEffect(() => {
    if (
      pendingScrollIndexRef.current != null &&
      dataSource.length > 0 &&
      !isFindMode
    ) {
      const idx = pendingScrollIndexRef.current;
      pendingScrollIndexRef.current = null;
      // On a fresh mount (e.g. arriving from another page) Virtuoso may not be
      // ready in a single frame, so retry a few times until the jump sticks.
      let attempts = 0;
      const tryScroll = () => {
        if (idx < 0 || idx >= dataSource.length) return;
        virtuosoRef.current?.scrollToIndex({ index: idx, align: "start" });
        attempts += 1;
        if (attempts < 6) window.setTimeout(tryScroll, 120);
      };
      window.requestAnimationFrame(tryScroll);
    }
  }, [dataSource, currentIndex, isFindMode]);

  const handleDeleteRecord = (key: string) => {
    setDataSource((prev) => prev.filter((record) => record.key !== key));
  };

  const handleNotPaidYetRecords = async () => {
    const filters = { paid: "No" };
    setCurrentFilters(filters);
    setActiveContent(null);
    await loadOrderTracking(filters);
  };

  const handleFindAllRecords = async () => {
    setCurrentFilters({});
    setSortRules([]);
    setActiveContent(null);
    await loadOrderTracking({}, { sortRules: [] });
  };
  const handleApplySortRules = async (nextRules: OrderTrackingSortRule[]) => {
    const normalized = normalizeOrderTrackingSortRules(nextRules);
    setSortRules(normalized);
    setIsSortDialogOpen(false);
    setActiveContent(null);
    setHasUserNavigated(true);

    const refreshed = await loadOrderTracking(currentFilters, {
      keepNavigation: true,
      sortRules: normalized,
    });

    setCurrentIndex(0);
    pendingScrollIndexRef.current = refreshed.length > 0 ? 0 : null;
  };

  const loadManufacturers = async () => {
    try {
      const data = await getManufacturers();
      const options = (Array.isArray(data) ? data : []).map((m: any) => ({
        value: m?.name,
        label: m?.name,
      }));
      setManufacturerOptions(options);
    } catch (error: any) {
      message.error(
        error?.response?.data?.message || "Failed to load manufacturers",
      );
    }
  };

  const handleDeleteCurrentRecord = async () => {
    if (!currentRecord) {
      message.warning("No order tracking record selected to delete");
      return;
    }

    if (!currentRecord.id) {
      message.warning("Current record does not have an id to delete");
      return;
    }

    const confirmed = window.confirm(
      "Are you sure you want to delete this order tracking record?",
    );
    if (!confirmed) return;

    try {
      const response = await deleteOrderTracking(currentRecord.id);
      const deleted = Number(response?.deleted || 0);

      if (deleted <= 0) {
        message.warning("No matching order tracking record was deleted");
        return;
      }

      // message.success("Order tracking record deleted successfully");
      // Remove from the local cache too, then reload from the server.
      otRemoveRecord(currentRecord.id);
      // Land on the record BEFORE the deleted one. Mark navigation intent and
      // keep it through the reload so the index-manager effect doesn't reset to
      // the top (the same race the New Record button had).
      const deletedIndex = currentIndex;
      setHasUserNavigated(true);
      const refreshed = await loadOrderTracking(currentFilters, {
        keepNavigation: true,
      });
      if (refreshed.length > 0) {
        const targetIndex = Math.min(
          Math.max(deletedIndex - 1, 0),
          refreshed.length - 1,
        );
        setCurrentIndex(targetIndex);
        pendingScrollIndexRef.current = targetIndex;
      } else {
        setCurrentIndex(0);
      }
    } catch (error: any) {
      message.error(
        error?.response?.data?.message ||
          "Failed to delete order tracking record",
      );
    }
  };

  const handleNewRecord = async () => {
    try {
      // Mark navigation intent BEFORE loading so the index-manager effect never
      // resets the selection to 0 while the reload commits (the live-only race).
      setHasUserNavigated(true);
      await createOrderTracking(buildCreatePayload(getBlankRecord()));
      const refreshed = await loadOrderTracking(currentFilters, {
        keepNavigation: true,
      });
      if (refreshed.length > 0) {
        // Records are ordered latest-first, so a newly created record is at the top.
        setCurrentIndex(0);
        pendingScrollIndexRef.current = 0;
      }
      setActiveContent(null);
    } catch (error) {
      console.error("Failed to create order tracking record:", error);
      message.error("Failed to create new record");
    }
  };

  const handleSaveRecord = (
    updatedRecord: OpenOrderData,
    previousRecord?: OpenOrderData,
  ) => {
    setDataSource((prev) =>
      prev.map((record) =>
        record.key === updatedRecord.key ? updatedRecord : record,
      ),
    );
    if (!String(updatedRecord.key).startsWith("new-")) {
      // 1) Update the local cache immediately (so a reload/return shows it).
      // 2) Mark it dirty until the DB save confirms.
      // 3) Silently sync to the DB (queueSilentUpdate clears dirty on success).
      lastEditAtRef.current = Date.now();
      const changes = buildChangedPayload(updatedRecord, previousRecord);
      if (!Object.keys(changes).length) return;
      if (updatedRecord.id != null) {
        otUpsertRecord(updatedRecord.id, changes);
        otMarkDirty(updatedRecord.id, changes);
      }
      queueSilentUpdate(updatedRecord.key, updatedRecord, previousRecord);
    }
  };

  // Only the fields the user actually changed. Sending the whole record would
  // write this page's (possibly stale) copy of fields another page updated —
  // e.g. serials synced from Open Order — back over the DB value.
  const buildChangedPayload = (
    updatedRecord: OpenOrderData,
    previousRecord?: OpenOrderData,
  ) => {
    const next = buildCreatePayload(updatedRecord);
    if (!previousRecord) return next;
    const prev = buildCreatePayload(previousRecord);
    return Object.fromEntries(
      Object.entries(next).filter(
        ([k, v]) => JSON.stringify(v) !== JSON.stringify(prev[k]),
      ),
    );
  };

  const queueSilentUpdate = (
    key: string,
    updatedRecord?: OpenOrderData,
    previousRecord?: OpenOrderData,
  ) => {
    const stateRecord = dataSource.find((item) => item.key === key);
    const latestRecord = updatedRecord || stateRecord;
    if (!latestRecord) return;
    const recordId = latestRecord?.id;
    if (!recordId) return;
    const payload = buildChangedPayload(latestRecord, previousRecord);
    if (!Object.keys(payload).length) return;

    // Merge, so several fields edited inside the debounce window all go out.
    pendingPayloadRef.current[key] = {
      ...(pendingPayloadRef.current[key] || {}),
      ...payload,
    };

    if (autosaveTimersRef.current[key]) {
      clearTimeout(autosaveTimersRef.current[key]);
    }

    autosaveTimersRef.current[key] = setTimeout(async () => {
      try {
        const batchedPayload = pendingPayloadRef.current[key];
        if (!batchedPayload) return;

        await updateOrderTracking(recordId, batchedPayload);
        // DB confirmed → cache and DB are in sync, clear the pending flag.
        otClearDirty(recordId);
      } catch (error) {
        console.error("Silent order tracking update failed", error);
        // Leave it dirty — flushOrderTrackingDirty() will retry it later.
      } finally {
        delete pendingPayloadRef.current[key];
        delete autosaveTimersRef.current[key];
      }
    }, 700);
  };

  const handleSaveNewRecord = async (newRecord: OpenOrderData) => {
    try {
      await createOrderTracking(buildCreatePayload(newRecord));
      const refreshed = await loadOrderTracking();
      if (refreshed.length > 0) {
        setHasUserNavigated(true);
        setCurrentIndex(0);
      }
      setActiveContent(null);
    } catch (error) {
      console.error("Failed to create order tracking record:", error);
    }
  };

  const handleUpdateRecord = (
    key: string,
    field: string,
    value: string,
    updatedRecord?: OpenOrderData,
    previousRecord?: OpenOrderData,
  ) => {
    void updatedRecord;
    void previousRecord;
    setDataSource((prev) =>
      prev.map((record) =>
        record.key === key ? { ...record, [field]: value } : record,
      ),
    );
  };

  const totalRecords = dataSource.length;
  const currentRecord = totalRecords > 0 ? dataSource[currentIndex] : undefined;
  const currentRecordDisplayNumber = totalRecords > 0 ? currentIndex + 1 : 0;
  const isFilterActive = Object.keys(currentFilters).length > 0;

  const handleRequestInvoice = async () => {
    if (!currentRecord) {
      message.warning("Select an order before requesting an invoice.");
      return;
    }

    if (currentRecord.invoiceRequestedAt) {
      const sentDate = dayjs(currentRecord.invoiceRequestedAt).format(
        "MM/DD/YYYY hh:mm A",
      );
      const proceed = window.confirm(
        `An invoice was already requested for this order on ${sentDate}. Send another request anyway?`,
      );
      if (!proceed) return;
    }

    const subjectId =
      currentRecord.quoteId || currentRecord.salesOrder || currentRecord.customer || "Order";
    const subject = `Invoice Request - ${subjectId}`;
    const modelSlots = [
      { model: currentRecord.model, sn: currentRecord.sn, tracking: currentRecord.trackingNo },
      { model: currentRecord.model2, sn: currentRecord.sn2, tracking: currentRecord.trackingNo2 },
      { model: currentRecord.model3, sn: currentRecord.sn3, tracking: currentRecord.trackingNo3 },
      { model: currentRecord.model4, sn: currentRecord.sn4, tracking: currentRecord.trackingNo4 },
      { model: currentRecord.model5, sn: currentRecord.sn5, tracking: currentRecord.trackingNo5 },
    ]
      .map((slot) => ({
        model: String(slot.model || "").trim(),
        sn: String(slot.sn || "").trim(),
        tracking: String(slot.tracking || "").trim(),
      }))
      .filter((slot) => slot.model);
    const modelLines = modelSlots.map(
      (slot) =>
        `${slot.model}  |  S#: ${slot.sn || "N/A"}  |  Tracking #: ${slot.tracking || "N/A"}`,
    );
    const details = [
      "Hello Accounting,",
      "",
      "Please create/send an invoice for the selected order below:",
      "",
      `Quote ID: ${currentRecord.quoteId || "N/A"}`,
      `Customer: ${currentRecord.customer || "N/A"}`,
      `Customer PO: ${currentRecord.custPo || "N/A"}`,
      `PO Date: ${currentRecord.poDate || "N/A"}`,
      `PO Status: ${currentRecord.poStatus || "N/A"}`,
      `Gross Sale: ${currentRecord.gs || "N/A"}`,
      `Shipping: ${currentRecord.shipping || "N/A"}`,
      "",
      "Model(s):",
      ...(modelLines.length > 0 ? modelLines : ["N/A"]),
      "",
      `Comments: ${currentRecord.comments || "N/A"}`,
    ].join("\n");

    window.location.href =
      `mailto:${encodeURIComponent("accounting@alliancetesteq.com")}` +
      `?cc=${encodeURIComponent("rkanna@alliancetesteq.com")}` +
      `&subject=${encodeURIComponent(subject)}` +
      `&body=${encodeURIComponent(details)}`;

    const sentAt = new Date().toISOString();
    setDataSource((prev) =>
      prev.map((r) =>
        r.key === currentRecord.key ? { ...r, invoiceRequestedAt: sentAt } : r,
      ),
    );
    if (currentRecord.id != null) {
      try {
        await updateOrderTracking(currentRecord.id, {
          invoice_requested_at: sentAt,
        });
        otUpsertRecord(currentRecord.id, { invoice_requested_at: sentAt });
      } catch (error) {
        console.error("Failed to record invoice request timestamp:", error);
      }
    }
  };

  useEffect(() => {
    setRecordInputValue(totalRecords > 0 ? String(currentIndex + 1) : "");
  }, [currentIndex, totalRecords]);

  const handleRecordInputCommit = (value: string) => {
    const parsed = Number.parseInt(value, 10);
    if (!Number.isFinite(parsed) || parsed < 1 || parsed > totalRecords) {
      setRecordInputValue(totalRecords > 0 ? String(currentIndex + 1) : "");
      return;
    }
    setIndexSafe(parsed - 1);
  };

  // Programmatic scroll. Used ONLY in two cases: restoring the saved
  // orderTrackingSelectedId on load, and jumping to the last record after the
  // New Record button. Next/previous and record-number navigation do NOT call
  // this (they only change the selection/count).
  const scrollToIndex = (index: number) => {
    if (index == null || index < 0 || index >= dataSource.length) return;
    virtuosoRef.current?.scrollToIndex({
      index,
      align: "start",
      behavior: "smooth",
    });
  };

  const handleSelectRecord = (record: OpenOrderData, index: number) => {
    setHasUserNavigated(true);
    setCurrentIndex(index);
    if (record?.id != null) {
      try {
        localStorage.setItem(OT_SELECTED_ID_KEY, String(record.id));
      } catch {
        /* ignore */
      }
    }
  };

  const setIndexSafe = (index: number) => {
    if (totalRecords === 0) return;
    const safeIndex = Math.min(
      Math.max(index, 0),
      Math.max(totalRecords - 1, 0),
    );
    setHasUserNavigated(true);
    setCurrentIndex(safeIndex);
    // Scroll the list to the record on next/previous/record-number navigation.
    scrollToIndex(safeIndex);
  };

  const handleRecordNumberChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const parsed = Number.parseInt(event.target.value, 10);
    if (!Number.isNaN(parsed) && totalRecords > 0) {
      const clamped = Math.min(Math.max(parsed, 1), totalRecords);
      setIndexSafe(clamped - 1);
    }
  };

  // Stable callbacks for the virtualized rows: keep the same identity across
  // renders (so React.memo on RecordDetail can skip unchanged rows) while
  // always delegating to the latest handler logic via a ref.
  const rowHandlersRef = useRef({
    handleDeleteRecord,
    handleSaveRecord,
    handleUpdateRecord,
    handleSaveNewRecord,
  });
  rowHandlersRef.current = {
    handleDeleteRecord,
    handleSaveRecord,
    handleUpdateRecord,
    handleSaveNewRecord,
  };

  const stableOnDelete = React.useCallback(
    (key: string) => rowHandlersRef.current.handleDeleteRecord(key),
    [],
  );
  const stableOnSave = React.useCallback(
    (record: OpenOrderData, previousRecord?: OpenOrderData) =>
      rowHandlersRef.current.handleSaveRecord(record, previousRecord),
    [],
  );
  const stableOnUpdate = React.useCallback(
    (
      key: string,
      field: string,
      value: string,
      updatedRecord?: OpenOrderData,
      previousRecord?: OpenOrderData,
    ) =>
      rowHandlersRef.current.handleUpdateRecord(
        key,
        field,
        value,
        updatedRecord,
        previousRecord,
      ),
    [],
  );
  const stableOnSaveNew = React.useCallback(
    (record: OpenOrderData) =>
      rowHandlersRef.current.handleSaveNewRecord(record),
    [],
  );

  // Modal openers — setState setters are already stable, so empty deps is safe.
  const stableOpenStatusModal = React.useCallback(
    () => setIsStatusModalOpen(true),
    [],
  );
  const stableOpenVendorModal = React.useCallback(
    () => setIsVendorModalOpen(true),
    [],
  );
  const stableOpenSourceModal = React.useCallback(
    () => setIsSourceModalOpen(true),
    [],
  );
  const stableOpenActionModal = React.useCallback(
    () => setIsActionModalOpen(true),
    [],
  );
  const stableOpenRepModal = React.useCallback(
    () => setIsRepModalOpen(true),
    [],
  );
  const stableOpenPmtModal = React.useCallback(
    () => setIsPmtModalOpen(true),
    [],
  );
  // Legacy button styles matching the original Order Tracking Center screenshot
  const pageHeaderButtonBase =
    "!text-black border !border-black text-[11px] h-[27px] rounded-none shadow-none px-3 font-normal leading-none";
  const btnGray = `${pageHeaderButtonBase} bg-[#e0e0e0] hover:bg-[#d0d0d0]`;
  const btnNewRecord = `${pageHeaderButtonBase} bg-[#ffff00] hover:bg-[#ffff00]`;
  const btnOTC = `${pageHeaderButtonBase} bg-[#00ff00] hover:bg-[#00ff00]`;
  const btnRequestInvoice = `${pageHeaderButtonBase} bg-[#ffcc66] hover:bg-[#f2b84b]`;

  const renderContent = () => {
    switch (activeContent) {
      case "find":
        return null;
      case "eqr":
        return <EQRContent onClose={handleCloseContent} />;
      case "findAll":
        return <FindAllContent onClose={handleCloseContent} />;
      case "notPaid":
        return <NotPaidYetContent onClose={handleCloseContent} />;
      default:
        return null;
    }
  };

  return (
    <div
      className="min-h-screen overflow-x-hidden"
      style={{ backgroundColor: "#CCFFCC" }}
    >
      <CommonHeader
        className="mb-0"
        currentRecord={recordInputValue}
        disableNext={totalRecords === 0 || currentIndex >= totalRecords - 1}
        disablePrevious={currentIndex <= 0 || totalRecords === 0}
        onDeleteRecord={handleDeleteCurrentRecord}
        isFindMode={isFindMode}
        onCancelFind={handleCancelFind}
        onFind={handleEnterFindMode}
        onPerformFind={handlePerformFind}
        onNewRecord={handleNewRecord}
        onNextRecord={() => setIndexSafe(currentIndex + 1)}
        onPreviousRecord={() => setIndexSafe(currentIndex - 1)}
        onRecordChange={setRecordInputValue}
        onRecordCommit={handleRecordInputCommit}
        onRecordSliderCommit={(index) => setIndexSafe(index)}
        onShowAll={handleFindAllRecords}
        onSort={() => setIsSortDialogOpen(true)}
        recordCount={totalRecords}
        recordIndex={Math.min(currentIndex, Math.max(totalRecords - 1, 0))}
        rightContent={<PageLogoutButton />}
        totalActiveCount={totalRecords}
        totalLabel={
          isFilterActive
            ? "Filtered"
            : sortRules.length > 0
              ? "Total (Sorted)"
              : "Total (Unsorted)"
        }
        totalRecordCount={unfilteredTotal}
        totalValue={
          isFilterActive ? `${totalRecords} / ${unfilteredTotal}` : totalRecords
        }
        exportColumns={ORDER_TRACKING_EXPORT_COLUMNS}
        getData={() => dataSource}
        onImport={async (data) => {
          await bulkImportOrderTracking(data);
        }}
        exportFilename="order-tracking"
      />
      {isSortDialogOpen && (
        <OrderTrackingSortDialog
          columns={ORDER_TRACKING_EXPORT_COLUMNS}
          value={sortRules}
          onApply={handleApplySortRules}
          onClose={() => setIsSortDialogOpen(false)}
        />
      )}
      {/* Top Navigation - all in blue background */}
      <div
        className="flex flex-col gap-1 px-[4px] pt-[1px] pb-[1px]"
        style={{ backgroundColor: "#3399FF" }}
      >
        {/* ROW 1: Heading + Page-specific Buttons — matches screenshot layout */}
        <div className="flex min-h-[68px] items-start">
          <h1 className="ml-[18px] mr-[84px] mt-[14px] whitespace-nowrap text-[37px] font-bold leading-none !text-black">
            Order Tracking Center
          </h1>

          {/* Find — sits alone, bottom-aligned */}
          <div className="mr-[60px] pt-[40px]">
            <Button
              className={`${btnGray} min-w-[56px]`}
              onClick={() => handleButtonClick("find")}
            >
              Find
            </Button>
          </div>

          {/* Quotes (top) + EQR (bottom) stacked column */}
          <div className="mr-[44px] flex flex-col gap-[5px] pt-[5px]">
            <Button
              className={`${btnGray} min-w-[72px]`}
              onClick={() => navigate("/Quotes")}
            >
              Quotes
            </Button>
            <Button
              className={`${btnGray} min-w-[72px]`}
              onClick={() => handleButtonClick("eqr")}
            >
              EQR
            </Button>
          </div>

          {/* Remaining buttons — centered vertically */}
          <div className="mt-[8px] flex items-start">
            <Button
              className={`${btnGray} mr-[46px] min-w-[136px]`}
              onClick={() => navigate("/open-order")}
            >
              Open Order Report
            </Button>
            <div className="mr-[104px] flex flex-col gap-[5px]">
              <Button
                className={`${btnOTC} min-w-[108px]`}
                onClick={() => navigate("/otc")}
              >
                OTC Snapshot
              </Button>
              <Tooltip
                title={
                  currentRecord?.invoiceRequestedAt
                    ? `Invoice requested ${dayjs(currentRecord.invoiceRequestedAt).format("MM/DD/YYYY hh:mm A")}`
                    : "No invoice request sent yet"
                }
              >
                <Button
                  className={`${btnRequestInvoice} min-w-[116px]`}
                  onClick={handleRequestInvoice}
                >
                  Request Invoice
                  {currentRecord?.invoiceRequestedAt && (
                    <CheckOutlined style={{ marginLeft: 6, color: "#0a7a2f" }} />
                  )}
                </Button>
              </Tooltip>
            </div>
            <Button
              className={`${btnNewRecord} mr-[102px] min-w-[100px]`}
              onClick={handleNewRecord}
            >
              New Record
            </Button>
            <Button
              className={`${btnGray} mt-[12px] mr-[72px] min-w-[100px]`}
              onClick={handleFindAllRecords}
            >
              Find ALL
            </Button>
            <Button
              className={`${btnGray} mt-[12px] min-w-[104px]`}
              onClick={handleNotPaidYetRecords}
            >
              Not Paid Yet
            </Button>
          </div>
        </div>
      </div>

      {/* Content panel */}
      {renderContent()}

      {/* Status Modal */}
      {isStatusModalOpen && (
        <>
          <div
            className="fixed inset-0 z-40 backdrop-blur-sm bg-white/30"
            onClick={() => setIsStatusModalOpen(false)}
          />
          <div className="fixed inset-0 z-50 flex items-start justify-center pt-20">
            <div className="relative bg-white rounded-lg shadow-xl border border-gray-300 w-80 max-h-96 overflow-hidden">
              <div className="p-3 border-b border-gray-200 flex justify-between items-center">
                <h3 className="text-[12px] font-semibold text-gray-700">
                  Edit PO Status Options
                </h3>
                <Button
                  type="text"
                  size="small"
                  className="h-5 w-5 p-0 text-gray-400 hover:text-gray-600"
                  onClick={() => setIsStatusModalOpen(false)}
                >
                  x
                </Button>
              </div>

              <div className="p-3 max-h-64 overflow-y-auto">
                <div className="space-y-2 mb-3">
                  {statusOptions.map((option, index) => (
                    <div
                      key={option.id ?? index}
                      className="flex items-center gap-1 group"
                    >
                      {editingStatus.index === index ? (
                        <>
                          <Input
                            value={editingStatus.value}
                            onChange={(e) =>
                              setEditingStatus({
                                ...editingStatus,
                                value: e.target.value,
                              })
                            }
                            size="small"
                            className="h-6 text-[10px] flex-1"
                            autoFocus
                            onPressEnter={handleSaveStatus}
                          />
                          <Button
                            type="primary"
                            size="small"
                            className="h-5 w-5 p-0 flex items-center justify-center bg-green-600 hover:bg-green-700"
                            onClick={handleSaveStatus}
                          >
                            <span className="text-[10px]">✓</span>
                          </Button>
                          <Button
                            type="text"
                            size="small"
                            className="h-5 w-5 p-0 flex items-center justify-center text-gray-500"
                            onClick={() =>
                              setEditingStatus({ index: -1, value: "" })
                            }
                          >
                            <span className="text-[10px]">x</span>
                          </Button>
                        </>
                      ) : (
                        <>
                          <span className="text-[10px] flex-1">
                            {option.label}
                          </span>
                          <div className="flex gap-1">
                            <Button
                              type="text"
                              size="small"
                              className="h-4 w-4 p-0 flex items-center justify-center text-gray-400 hover:text-blue-600"
                              onClick={() => handleEditStatus(index)}
                            >
                              <EditOutlined className="text-[12px]" />
                            </Button>
                            <Button
                              type="text"
                              size="small"
                              className="h-4 w-4 p-0 flex items-center justify-center text-gray-400 hover:text-red-600"
                              onClick={() => handleDeleteStatus(index)}
                            >
                              <DeleteOutlined className="text-[12px]" />
                            </Button>
                          </div>
                        </>
                      )}
                    </div>
                  ))}
                </div>

                <div className="border-t border-gray-200 pt-2">
                  <div className="text-[10px] font-medium text-gray-500 mb-1">
                    Add New Status
                  </div>
                  <div className="flex items-center gap-1">
                    <Input
                      placeholder="Enter new status"
                      value={newStatus}
                      onChange={(e) => setNewStatus(e.target.value)}
                      size="small"
                      className="h-6 text-[10px] flex-1"
                      onPressEnter={handleAddStatus}
                    />
                    <Button
                      type="primary"
                      size="small"
                      className="h-6 px-2 text-[9px] bg-[#004aad]"
                      onClick={handleAddStatus}
                    >
                      Add
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {/* Actions Modal (status table, type "otc-actions") */}
      {isActionModalOpen && (
        <>
          <div
            className="fixed inset-0 z-40 backdrop-blur-sm bg-white/30"
            onClick={() => setIsActionModalOpen(false)}
          />
          <div className="fixed inset-0 z-50 flex items-start justify-center pt-20">
            <div className="relative bg-white rounded-lg shadow-xl border border-gray-300 w-80 max-h-96 overflow-hidden">
              <div className="p-3 border-b border-gray-200 flex justify-between items-center">
                <h3 className="text-[12px] font-semibold text-gray-700">
                  Edit Action Options
                </h3>
                <Button
                  type="text"
                  size="small"
                  className="h-5 w-5 p-0 text-gray-400 hover:text-gray-600"
                  onClick={() => setIsActionModalOpen(false)}
                >
                  x
                </Button>
              </div>

              <div className="p-3 max-h-64 overflow-y-auto">
                <div className="space-y-2 mb-3">
                  {actionOptions.map((option, index) => (
                    <div
                      key={option.id ?? index}
                      className="flex items-center gap-1 group"
                    >
                      {editingAction.index === index ? (
                        <>
                          <Input
                            value={editingAction.value}
                            onChange={(e) =>
                              setEditingAction({
                                ...editingAction,
                                value: e.target.value,
                              })
                            }
                            size="small"
                            className="h-6 text-[10px] flex-1"
                            autoFocus
                            onPressEnter={handleSaveAction}
                          />
                          <Button
                            type="primary"
                            size="small"
                            className="h-5 w-5 p-0 flex items-center justify-center bg-green-600 hover:bg-green-700"
                            onClick={handleSaveAction}
                          >
                            <span className="text-[10px]">✓</span>
                          </Button>
                          <Button
                            type="text"
                            size="small"
                            className="h-5 w-5 p-0 flex items-center justify-center text-gray-500"
                            onClick={() =>
                              setEditingAction({ index: -1, value: "" })
                            }
                          >
                            <span className="text-[10px]">x</span>
                          </Button>
                        </>
                      ) : (
                        <>
                          <span className="text-[10px] flex-1">
                            {option.label}
                          </span>
                          <div className="flex gap-1">
                            <Button
                              type="text"
                              size="small"
                              className="h-4 w-4 p-0 flex items-center justify-center text-gray-400 hover:text-blue-600"
                              onClick={() => handleEditAction(index)}
                            >
                              <EditOutlined className="text-[12px]" />
                            </Button>
                            <Button
                              type="text"
                              size="small"
                              className="h-4 w-4 p-0 flex items-center justify-center text-gray-400 hover:text-red-600"
                              onClick={() => handleDeleteAction(index)}
                            >
                              <DeleteOutlined className="text-[12px]" />
                            </Button>
                          </div>
                        </>
                      )}
                    </div>
                  ))}
                </div>

                <div className="border-t border-gray-200 pt-2">
                  <div className="text-[10px] font-medium text-gray-500 mb-1">
                    Add New Action
                  </div>
                  <div className="flex items-center gap-1">
                    <Input
                      placeholder="Enter new action"
                      value={newAction}
                      onChange={(e) => setNewAction(e.target.value)}
                      size="small"
                      className="h-6 text-[10px] flex-1"
                      onPressEnter={handleAddAction}
                    />
                    <Button
                      type="primary"
                      size="small"
                      className="h-6 px-2 text-[9px] bg-[#004aad]"
                      onClick={handleAddAction}
                    >
                      Add
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {isVendorModalOpen && (
        <>
          <div
            className="fixed inset-0 z-40 backdrop-blur-sm bg-white/30"
            onClick={() => {
              setIsVendorModalOpen(false);
              setEditingVendor(null);
              setNewVendorName("");
            }}
          />

          <div className="fixed inset-0 z-50 flex items-start justify-center pt-20">
            <div className="relative bg-white rounded-lg shadow-xl border border-gray-300 w-96 max-h-[500px] overflow-hidden">
              <div className="p-3 border-b border-gray-200 flex justify-between items-center bg-gray-50">
                <h3 className="text-[14px] font-semibold text-gray-700">
                  Manage Vendors
                </h3>
                <Button
                  type="text"
                  size="small"
                  className="h-6 w-6 p-0 text-gray-400 hover:text-gray-600"
                  onClick={() => {
                    setIsVendorModalOpen(false);
                    setEditingVendor(null);
                    setNewVendorName("");
                  }}
                >
                  x
                </Button>
              </div>

              <div className="p-3 max-h-[380px] overflow-y-auto">
                <div className="space-y-2 mb-3">
                  <div className="text-[11px] font-medium text-gray-500 mb-2">
                    Existing Vendors ({vendors.length})
                  </div>
                  {vendors.map((vendor) => (
                    <div
                      key={vendor.id}
                      className="flex items-center gap-1 group bg-gray-50 rounded p-1.5"
                    >
                      {editingVendor?.id === vendor.id ? (
                        <>
                          <Input
                            value={editingVendor.name}
                            onChange={(e) =>
                              setEditingVendor({
                                ...editingVendor,
                                name: e.target.value,
                              })
                            }
                            size="small"
                            className="h-7 text-[11px] flex-1"
                            autoFocus
                            onPressEnter={handleUpdateVendor}
                          />
                          <Button
                            type="primary"
                            size="small"
                            className="h-6 w-6 p-0 flex items-center justify-center bg-green-600 hover:bg-green-700"
                            onClick={handleUpdateVendor}
                          >
                            <CheckOutlined className="text-[12px]" />
                          </Button>
                          <Button
                            type="text"
                            size="small"
                            className="h-6 w-6 p-0 flex items-center justify-center text-gray-500"
                            onClick={() => setEditingVendor(null)}
                          >
                            <CloseOutlined className="text-[12px]" />
                          </Button>
                        </>
                      ) : (
                        <>
                          <span className="text-[11px] flex-1">
                            {vendor.name}
                          </span>
                          <div className="flex gap-1 opacity-100">
                            <Button
                              type="text"
                              size="small"
                              className="h-5 w-5 p-0 flex items-center justify-center text-blue-600 hover:text-blue-700"
                              onClick={() =>
                                setEditingVendor({
                                  id: vendor.id,
                                  name: vendor.name,
                                })
                              }
                            >
                              <EditOutlined className="text-[12px]" />
                            </Button>
                            <Button
                              type="text"
                              size="small"
                              className="h-5 w-5 p-0 flex items-center justify-center text-red-600 hover:text-red-700"
                              onClick={() =>
                                handleDeleteVendor(vendor.id, vendor.name)
                              }
                            >
                              <DeleteOutlined className="text-[12px]" />
                            </Button>
                          </div>
                        </>
                      )}
                    </div>
                  ))}

                  {!vendorsLoading && vendors.length === 0 && (
                    <div className="text-center text-gray-400 text-[11px] py-4">
                      No vendors added yet
                    </div>
                  )}
                </div>

                <div className="border-t border-gray-200 pt-3">
                  <div className="text-[11px] font-medium text-gray-500 mb-2">
                    Add New Vendor
                  </div>
                  <div className="flex items-center gap-2">
                    <Input
                      placeholder="Enter vendor name"
                      value={newVendorName}
                      onChange={(e) => setNewVendorName(e.target.value)}
                      size="small"
                      className="h-7 text-[11px] flex-1"
                      onPressEnter={handleAddVendor}
                    />
                    <Button
                      type="primary"
                      size="small"
                      className="h-7 px-3 text-[11px] bg-[#004aad]"
                      onClick={handleAddVendor}
                    >
                      Add
                    </Button>
                  </div>
                </div>
              </div>

              <div className="p-2 border-t border-gray-200 flex justify-end bg-gray-50">
                <Button
                  size="small"
                  className="h-7 px-3 text-[11px]"
                  onClick={() => {
                    setIsVendorModalOpen(false);
                    setEditingVendor(null);
                    setNewVendorName("");
                  }}
                >
                  Close
                </Button>
              </div>
            </div>
          </div>
        </>
      )}

      {isSourceModalOpen && (
        <>
          <div
            className="fixed inset-0 z-40 backdrop-blur-sm bg-white/30"
            onClick={() => setIsSourceModalOpen(false)}
          />
          <div className="fixed inset-0 z-50 flex items-start justify-center pt-20">
            <div className="relative bg-white rounded-lg shadow-xl border border-gray-300 w-80 max-h-96 overflow-hidden">
              <div className="p-3 border-b border-gray-200 flex justify-between items-center">
                <h3 className="text-[12px] font-semibold text-gray-700">
                  Edit Lead From Options
                </h3>
                <Button
                  type="text"
                  size="small"
                  className="h-5 w-5 p-0 text-gray-400 hover:text-gray-600"
                  onClick={() => setIsSourceModalOpen(false)}
                >
                  x
                </Button>
              </div>

              <div className="p-3 max-h-64 overflow-y-auto">
                <div className="space-y-2 mb-3">
                  {sourceOptions.map((option, index) => (
                    <div
                      key={option.id ?? index}
                      className="flex items-center gap-1 group"
                    >
                      {editingSource.index === index ? (
                        <>
                          <Input
                            value={editingSource.value}
                            onChange={(e) =>
                              setEditingSource({
                                ...editingSource,
                                value: e.target.value,
                              })
                            }
                            size="small"
                            className="h-6 text-[10px] flex-1"
                            autoFocus
                            onPressEnter={handleSaveSource}
                          />
                          <Button
                            type="primary"
                            size="small"
                            className="h-5 w-5 p-0 flex items-center justify-center bg-green-600 hover:bg-green-700"
                            onClick={handleSaveSource}
                          >
                            <span className="text-[10px]">✓</span>
                          </Button>
                          <Button
                            type="text"
                            size="small"
                            className="h-5 w-5 p-0 flex items-center justify-center text-gray-500"
                            onClick={() =>
                              setEditingSource({ index: -1, value: "", id: 0 })
                            }
                          >
                            <span className="text-[10px]">x</span>
                          </Button>
                        </>
                      ) : (
                        <>
                          <span className="text-[10px] flex-1">
                            {option.label}
                          </span>
                          <div className="flex gap-1">
                            <Button
                              type="text"
                              size="small"
                              className="h-4 w-4 p-0 flex items-center justify-center text-gray-400 hover:text-blue-600"
                              onClick={() => handleEditSource(index)}
                            >
                              <EditOutlined className="text-[12px]" />
                            </Button>
                            <Button
                              type="text"
                              size="small"
                              className="h-4 w-4 p-0 flex items-center justify-center text-gray-400 hover:text-red-600"
                              onClick={() => handleDeleteSource(index)}
                            >
                              <DeleteOutlined className="text-[12px]" />
                            </Button>
                          </div>
                        </>
                      )}
                    </div>
                  ))}
                </div>

                <div className="border-t border-gray-200 pt-2">
                  <div className="text-[10px] font-medium text-gray-500 mb-1">
                    Add New Lead From
                  </div>
                  <div className="flex items-center gap-1">
                    <Input
                      placeholder="Enter new lead from"
                      value={newSource}
                      onChange={(e) => setNewSource(e.target.value)}
                      size="small"
                      className="h-6 text-[10px] flex-1"
                      onPressEnter={handleAddSource}
                    />
                    <Button
                      type="primary"
                      size="small"
                      className="h-6 px-2 text-[9px] bg-[#004aad]"
                      onClick={handleAddSource}
                    >
                      Add
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {/* Rep Modal */}
      {isRepModalOpen && (
        <>
          <div
            className="fixed inset-0 z-40 backdrop-blur-sm bg-white/30"
            onClick={() => {
              setIsRepModalOpen(false);
              setEditingRep(null);
              setNewRepName("");
            }}
          />
          <div className="fixed inset-0 z-50 flex items-start justify-center pt-20">
            <div className="relative bg-white rounded-lg shadow-xl border border-gray-300 w-80 max-h-96 overflow-hidden">
              <div className="p-3 border-b border-gray-200 flex justify-between items-center">
                <h3 className="text-[12px] font-semibold text-gray-700">
                  Edit Rep Options
                </h3>
                <Button
                  type="text"
                  size="small"
                  className="h-5 w-5 p-0"
                  onClick={() => {
                    setIsRepModalOpen(false);
                    setEditingRep(null);
                    setNewRepName("");
                  }}
                >
                  x
                </Button>
              </div>
              <div className="p-3 max-h-64 overflow-y-auto">
                <div className="space-y-2 mb-3">
                  {otcReps.map((rep) => (
                    <div key={rep.id} className="flex items-center gap-1 group">
                      {editingRep?.id === rep.id ? (
                        <>
                          <Input
                            value={editingRep.name}
                            onChange={(e) =>
                              setEditingRep({
                                ...editingRep,
                                name: e.target.value,
                              })
                            }
                            size="small"
                            className="h-6 text-[10px] flex-1"
                            autoFocus
                            onPressEnter={async () => {
                              if (!editingRep.name.trim()) return;
                              await updateOtcRep(
                                editingRep.id,
                                editingRep.name.trim(),
                              );
                              setEditingRep(null);
                              refreshOtcReps();
                            }}
                          />
                          <Button
                            type="primary"
                            size="small"
                            className="h-5 w-5 p-0 flex items-center justify-center bg-green-600"
                            onClick={async () => {
                              if (!editingRep.name.trim()) return;
                              await updateOtcRep(
                                editingRep.id,
                                editingRep.name.trim(),
                              );
                              setEditingRep(null);
                              refreshOtcReps();
                            }}
                          >
                            <span className="text-[10px]">✓</span>
                          </Button>
                          <Button
                            type="text"
                            size="small"
                            className="h-5 w-5 p-0"
                            onClick={() => setEditingRep(null)}
                          >
                            <span className="text-[10px]">x</span>
                          </Button>
                        </>
                      ) : (
                        <>
                          <span className="text-[10px] flex-1">{rep.name}</span>
                          <Button
                            type="text"
                            size="small"
                            className="h-4 w-4 p-0 text-gray-400 hover:text-blue-600"
                            onClick={() =>
                              setEditingRep({ id: rep.id, name: rep.name })
                            }
                          >
                            <EditOutlined className="text-[12px]" />
                          </Button>
                          <Button
                            type="text"
                            size="small"
                            className="h-4 w-4 p-0 text-gray-400 hover:text-red-600"
                            onClick={async () => {
                              await deleteOtcRep(rep.id);
                              refreshOtcReps();
                            }}
                          >
                            <DeleteOutlined className="text-[12px]" />
                          </Button>
                        </>
                      )}
                    </div>
                  ))}
                </div>
                <div className="border-t border-gray-200 pt-2">
                  <div className="text-[10px] font-medium text-gray-500 mb-1">
                    Add New Rep
                  </div>
                  <div className="flex items-center gap-1">
                    <Input
                      placeholder="Enter rep name"
                      value={newRepName}
                      onChange={(e) => setNewRepName(e.target.value)}
                      size="small"
                      className="h-6 text-[10px] flex-1"
                      onPressEnter={async () => {
                        if (!newRepName.trim()) return;
                        await createOtcRep(newRepName.trim());
                        setNewRepName("");
                        refreshOtcReps();
                      }}
                    />
                    <Button
                      type="primary"
                      size="small"
                      className="h-6 px-2 text-[9px] bg-[#004aad]"
                      onClick={async () => {
                        if (!newRepName.trim()) return;
                        await createOtcRep(newRepName.trim());
                        setNewRepName("");
                        refreshOtcReps();
                      }}
                    >
                      Add
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {/* Pmt Modal */}
      {isPmtModalOpen && (
        <>
          <div
            className="fixed inset-0 z-40 backdrop-blur-sm bg-white/30"
            onClick={() => {
              setIsPmtModalOpen(false);
              setEditingPmt(null);
              setNewPmtName("");
            }}
          />
          <div className="fixed inset-0 z-50 flex items-start justify-center pt-20">
            <div className="relative bg-white rounded-lg shadow-xl border border-gray-300 w-80 max-h-96 overflow-hidden">
              <div className="p-3 border-b border-gray-200 flex justify-between items-center">
                <h3 className="text-[12px] font-semibold text-gray-700">
                  Edit Pmt Options
                </h3>
                <Button
                  type="text"
                  size="small"
                  className="h-5 w-5 p-0"
                  onClick={() => {
                    setIsPmtModalOpen(false);
                    setEditingPmt(null);
                    setNewPmtName("");
                  }}
                >
                  x
                </Button>
              </div>
              <div className="p-3 max-h-64 overflow-y-auto">
                <div className="space-y-2 mb-3">
                  {otcPmts.map((pmt) => (
                    <div key={pmt.id} className="flex items-center gap-1 group">
                      {editingPmt?.id === pmt.id ? (
                        <>
                          <Input
                            value={editingPmt.name}
                            onChange={(e) =>
                              setEditingPmt({
                                ...editingPmt,
                                name: e.target.value,
                              })
                            }
                            size="small"
                            className="h-6 text-[10px] flex-1"
                            autoFocus
                            onPressEnter={async () => {
                              if (!editingPmt.name.trim()) return;
                              await updateOtcPmt(
                                editingPmt.id,
                                editingPmt.name.trim(),
                              );
                              setEditingPmt(null);
                              refreshOtcPmts();
                            }}
                          />
                          <Button
                            type="primary"
                            size="small"
                            className="h-5 w-5 p-0 flex items-center justify-center bg-green-600"
                            onClick={async () => {
                              if (!editingPmt.name.trim()) return;
                              await updateOtcPmt(
                                editingPmt.id,
                                editingPmt.name.trim(),
                              );
                              setEditingPmt(null);
                              refreshOtcPmts();
                            }}
                          >
                            <span className="text-[10px]">✓</span>
                          </Button>
                          <Button
                            type="text"
                            size="small"
                            className="h-5 w-5 p-0"
                            onClick={() => setEditingPmt(null)}
                          >
                            <span className="text-[10px]">x</span>
                          </Button>
                        </>
                      ) : (
                        <>
                          <span className="text-[10px] flex-1">{pmt.name}</span>
                          <Button
                            type="text"
                            size="small"
                            className="h-4 w-4 p-0 text-gray-400 hover:text-blue-600"
                            onClick={() =>
                              setEditingPmt({ id: pmt.id, name: pmt.name })
                            }
                          >
                            <EditOutlined className="text-[12px]" />
                          </Button>
                          <Button
                            type="text"
                            size="small"
                            className="h-4 w-4 p-0 text-gray-400 hover:text-red-600"
                            onClick={async () => {
                              await deleteOtcPmt(pmt.id);
                              refreshOtcPmts();
                            }}
                          >
                            <DeleteOutlined className="text-[12px]" />
                          </Button>
                        </>
                      )}
                    </div>
                  ))}
                </div>
                <div className="border-t border-gray-200 pt-2">
                  <div className="text-[10px] font-medium text-gray-500 mb-1">
                    Add New Pmt
                  </div>
                  <div className="flex items-center gap-1">
                    <Input
                      placeholder="Enter pmt name"
                      value={newPmtName}
                      onChange={(e) => setNewPmtName(e.target.value)}
                      size="small"
                      className="h-6 text-[10px] flex-1"
                      onPressEnter={async () => {
                        if (!newPmtName.trim()) return;
                        await createOtcPmt(newPmtName.trim());
                        setNewPmtName("");
                        refreshOtcPmts();
                      }}
                    />
                    <Button
                      type="primary"
                      size="small"
                      className="h-6 px-2 text-[9px] bg-[#004aad]"
                      onClick={async () => {
                        if (!newPmtName.trim()) return;
                        await createOtcPmt(newPmtName.trim());
                        setNewPmtName("");
                        refreshOtcPmts();
                      }}
                    >
                      Add
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {/* Records view */}
      <div>
        {isLoading ? (
          <div className="p-6 text-center text-gray-500">
            Loading order tracking records...
          </div>
        ) : isFindMode ? (
          <RecordDetail
            record={currentRecord || getBlankRecord()}
            isNew={false}
            onDelete={handleDeleteRecord}
            onSave={handleSaveRecord}
            onUpdate={handleUpdateRecord}
            onSaveNew={handleSaveNewRecord}
            statusOptions={statusOptions}
            manufacturerOptions={manufacturerOptions}
            vendors={vendors}
            sourceOptions={sourceOptions}
            actionOptions={actionOptions}
            otcReps={otcReps}
            otcPmts={otcPmts}
            onOpenStatusModal={() => setIsStatusModalOpen(true)}
            onOpenVendorModal={() => setIsVendorModalOpen(true)}
            onOpenSourceModal={() => setIsSourceModalOpen(true)}
            onOpenActionModal={() => setIsActionModalOpen(true)}
            onOpenRepModal={() => setIsRepModalOpen(true)}
            onOpenPmtModal={() => setIsPmtModalOpen(true)}
            isFindMode={true}
            findCriteria={findCriteria}
            onFindCriteriaChange={(field, value) =>
              setFindCriteria((prev) => ({ ...prev, [field]: value }))
            }
          />
        ) : dataSource.length > 0 ? (
          <Virtuoso
            ref={virtuosoRef}
            className="ot-scroller"
            style={{ height: "calc(100vh - 160px)" }}
            data={dataSource}
            increaseViewportBy={{ top: 600, bottom: 600 }}
            // Tell Virtuoso the approximate row height so a scrollbar drag
            // lands in the right place instead of guessing wrong and then
            // correcting the scroll position (which is what caused the glitch).
            // All RecordDetail rows are structurally identical, so one value
            // fits them all. Fine-tune if rows look slightly mis-spaced.
            defaultItemHeight={490}
            computeItemKey={(_, rec) => rec.key}
            itemContent={(index, rec) => (
              <div
                onClick={() => handleSelectRecord(rec, index)}
                style={{ position: "relative" }}
              >
                {/* Black left line for the selected record, drawn as an overlay
                    (not a border) so it sits at the true left edge and connects
                    with the black footer divider — without shifting any content. */}
                {index === currentIndex && (
                  <div
                    style={{
                      position: "absolute",
                      left: 0,
                      top: 0,
                      bottom: 0,
                      width: 6,
                      backgroundColor: "#000000",
                      zIndex: 2,
                      pointerEvents: "none",
                    }}
                  />
                )}
                <RecordDetail
                  record={rec}
                  isNew={false}
                  onDelete={stableOnDelete}
                  onSave={stableOnSave}
                  onUpdate={stableOnUpdate}
                  onSaveNew={stableOnSaveNew}
                  statusOptions={statusOptions}
                  manufacturerOptions={manufacturerOptions}
                  vendors={vendors}
                  sourceOptions={sourceOptions}
                  actionOptions={actionOptions}
                  otcReps={otcReps}
                  otcPmts={otcPmts}
                  onOpenStatusModal={stableOpenStatusModal}
                  onOpenVendorModal={stableOpenVendorModal}
                  onOpenSourceModal={stableOpenSourceModal}
                  onOpenActionModal={stableOpenActionModal}
                  onOpenRepModal={stableOpenRepModal}
                  onOpenPmtModal={stableOpenPmtModal}
                  isFindMode={false}
                />
              </div>
            )}
          />
        ) : (
          <div className="p-6 text-center text-gray-500">
            No order tracking records found.
          </div>
        )}
      </div>
    </div>
  );
};

export default OrderTracking;
